var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _path, _rect200, _polygon, _rect201, _path2, _g, _rect202, _path3, _g2, _rect203, _rect204, _rect205;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstructioncraneCuate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-183"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.38,68.74c7.19,0,128.17,.8,135.77,.55,.55-.02,.84-.82,.3-1.09-4.79-2.37-10.23-1.9-15.21-3.58-2.93-.99-4.73-2.9-6.76-5.1-1.76-1.9-3.79-3.36-6.3-4.11-2.21-.66-4.61-.75-6.85-.21-2.45,.59-4.59,1.99-6.93,2.88-5.81,2.19-11.46,.11-15.61-4.19-3.42-3.54-6.79-6.89-11.44-8.8-3.9-1.6-8.22-1.93-12.12-.17-4.44,2.01-7.48,6.05-11.65,8.49-4.94,2.89-10.85,2.21-16.31,3.08-5.47,.87-9.65,5.47-14.43,8.11-1.64,.91-3.31,1.66-5.22,1.62-1.07-.03-2.12-.32-3.18-.45-1.65-.2-3.21-.16-4.32,1.22-.27,.34-.21,1.76,.26,1.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.48,99.48c5.25,0,93.58,.58,99.13,.4,.4-.01,.61-.6,.22-.8-3.5-1.73-7.47-1.38-11.11-2.61-2.14-.72-3.45-2.12-4.94-3.72-1.28-1.39-2.77-2.45-4.6-3-1.62-.48-3.36-.55-5-.16-1.79,.43-3.35,1.45-5.06,2.1-4.24,1.6-8.37,.08-11.4-3.06-2.5-2.59-4.96-5.03-8.35-6.42-2.84-1.17-6-1.41-8.85-.12-3.24,1.47-5.46,4.42-8.51,6.2-3.61,2.11-7.92,1.61-11.91,2.25-4,.64-7.04,3.99-10.54,5.92-1.19,.66-2.42,1.21-3.81,1.18-.78-.02-1.55-.23-2.32-.33-1.2-.15-2.35-.11-3.15,.89-.2,.25-.16,1.28,.19,1.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.14,203.17c5.25,0,93.58,.58,99.13,.4,.4-.01,.61-.6,.22-.8-3.5-1.73-7.47-1.38-11.11-2.61-2.14-.72-3.45-2.12-4.94-3.72-1.28-1.39-2.77-2.45-4.6-3-1.62-.48-3.36-.55-5-.16-1.79,.43-3.35,1.45-5.06,2.1-4.24,1.6-8.37,.08-11.4-3.06-2.5-2.59-4.96-5.03-8.35-6.42-2.84-1.17-6-1.41-8.85-.12-3.24,1.47-5.46,4.42-8.51,6.2-3.61,2.11-7.92,1.61-11.91,2.25-4,.64-7.04,3.99-10.54,5.92-1.19,.66-2.42,1.21-3.81,1.18-.78-.02-1.55-.23-2.32-.33-1.2-.15-2.35-.11-3.15,.89-.2,.25-.16,1.28,.19,1.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.44,173.06c.1,.3,139.22,0,137.46,0-.8,0,1.21-1.2,.43-1.58-4.53-2.25-9.48-2.31-14.41-2.76-2.88-.26-5.83-.68-8.42-2.04-2.62-1.37-4.26-3.76-6.12-5.96-5.75-6.83-14.9-10.39-23.76-9-9.89,1.55-17.69,9.09-27.6,10.47-5.95,.83-11.58-1.47-17.4-2.28-4.79-.66-8.78,.27-13.06,2.39-3.14,1.56-6.04,2.87-9.58,3.11-2.72,.19-5.46-.12-8.19-.15-4.37-.04-8.68,1.85-12.05,4.82-.44,.39-1.84,2.99,2.7,2.99Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "435.54 310.69 435.89 310.69 435.89 281.39 434.52 279.57 436.68 241.16 436.65 241.12 401.28 173.63 396.52 171.98 396.46 172 235.32 228.96 235.44 229.29 396.52 172.35 401.03 173.91 436.32 241.24 434.17 279.69 435.54 281.51 435.54 310.69",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.91 310.69 432.26 310.69 432.26 281.51 433.64 279.69 433.63 279.63 431.48 241.16 431.46 241.12 398.72 175.76 398.4 175.92 431.13 241.25 433.28 279.57 431.91 281.39 431.91 310.69",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 377.53,
    y: 451.99,
    width: 64.35,
    height: 5.07,
    transform: "translate(819.41 909.05) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.72,
    y: 457.06,
    width: 71.97,
    height: 6.99,
    transform: "translate(819.41 921.11) rotate(180)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M391.7,403.6v-24.46h13.71v24.51l-4.35,45.07h-5.01l-4.35-45.12Zm12.66,0v-23.41h-11.61v23.36l4.26,44.12h3.1l4.26-44.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.23,
    y: 403.07,
    width: 12.66,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.56 403.2 405.4 379.81 404.39 379.52 398.56 399.45 392.73 379.52 391.72 379.81 398.56 403.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.25 426 403.28 425.8 398.56 401.47 393.86 425.8 394.9 426 398.56 407 402.25 426",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.03,
    y: 403.6,
    width: 1.05,
    height: 44.59,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M389.48,403.6v-24.46h3.27v24.42l3.67,45.16h-1.75l-5.19-45.12Zm1.05-23.41v23.35l3.95,34.41-2.79-34.35v-23.41h-1.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.01,
    y: 403.07,
    width: 2.22,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.64 401.35 392.75 379.69 391.7 379.64 391.12 391.04 390.54 379.64 389.49 379.69 390.59 401.35 391.64 401.35",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.78,
    y: 403.49,
    width: 1.05,
    height: 44.81,
    transform: "translate(-39.71 40.44) rotate(-5.6)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M391.71,216.54l5.39-41.23h2.93l5.39,41.3v22.41h-13.71v-22.48Zm12.67,.14l-5.27-40.31h-1.08l-5.26,40.24v21.36h11.61v-21.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.23,
    y: 216.08,
    width: 12.66,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.73 238.65 398.56 220.42 404.39 238.65 405.39 238.33 398.56 216.96 391.73 238.33 392.73 238.65",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.56 218.91 402.74 196.32 401.71 196.13 398.56 213.15 395.4 196.18 394.37 196.38 398.56 218.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.03,
    y: 175.84,
    width: 1.05,
    height: 40.77,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 399.58,
    y: 257.2,
    width: 0.6,
    height: 194.79,
    transform: "translate(799.76 709.19) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.94,
    y: 257.2,
    width: 0.6,
    height: 194.79,
    transform: "translate(794.48 709.19) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 449.58,
    width: 0.6,
    height: 2.04,
    transform: "translate(849.15 52.04) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 447.58,
    width: 0.6,
    height: 2.04,
    transform: "translate(847.16 50.04) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 445.59,
    width: 0.6,
    height: 2.04,
    transform: "translate(845.16 48.04) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 443.59,
    width: 0.6,
    height: 2.04,
    transform: "translate(843.17 46.05) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 441.6,
    width: 0.6,
    height: 2.04,
    transform: "translate(841.17 44.05) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 439.6,
    width: 0.6,
    height: 2.04,
    transform: "translate(839.18 42.06) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 437.61,
    width: 0.6,
    height: 2.04,
    transform: "translate(837.18 40.06) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 435.61,
    width: 0.6,
    height: 2.04,
    transform: "translate(835.19 38.07) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 433.62,
    width: 0.6,
    height: 2.04,
    transform: "translate(833.19 36.07) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 431.62,
    width: 0.6,
    height: 2.04,
    transform: "translate(831.2 34.08) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 429.62,
    width: 0.6,
    height: 2.04,
    transform: "translate(829.2 32.08) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 427.63,
    width: 0.6,
    height: 2.04,
    transform: "translate(827.21 30.09) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 425.63,
    width: 0.6,
    height: 2.04,
    transform: "translate(825.21 28.09) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 423.64,
    width: 0.6,
    height: 2.04,
    transform: "translate(823.22 26.1) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 421.64,
    width: 0.6,
    height: 2.04,
    transform: "translate(821.22 24.1) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 419.65,
    width: 0.6,
    height: 2.04,
    transform: "translate(819.23 22.11) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 417.65,
    width: 0.6,
    height: 2.04,
    transform: "translate(817.23 20.11) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 415.66,
    width: 0.6,
    height: 2.04,
    transform: "translate(815.24 18.12) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 413.66,
    width: 0.6,
    height: 2.04,
    transform: "translate(813.24 16.12) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 411.67,
    width: 0.6,
    height: 2.04,
    transform: "translate(811.25 14.13) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 409.67,
    width: 0.6,
    height: 2.04,
    transform: "translate(809.25 12.13) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 407.68,
    width: 0.6,
    height: 2.04,
    transform: "translate(807.26 10.14) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 405.68,
    width: 0.6,
    height: 2.04,
    transform: "translate(805.26 8.14) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 403.69,
    width: 0.6,
    height: 2.04,
    transform: "translate(803.27 6.15) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 401.69,
    width: 0.6,
    height: 2.04,
    transform: "translate(801.27 4.15) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 399.7,
    width: 0.6,
    height: 2.04,
    transform: "translate(799.28 2.16) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 397.7,
    width: 0.6,
    height: 2.04,
    transform: "translate(797.28 .16) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 395.71,
    width: 0.6,
    height: 2.04,
    transform: "translate(795.28 -1.83) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 393.71,
    width: 0.6,
    height: 2.04,
    transform: "translate(793.29 -3.83) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 391.72,
    width: 0.6,
    height: 2.04,
    transform: "translate(791.29 -5.82) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 389.72,
    width: 0.6,
    height: 2.04,
    transform: "translate(789.3 -7.82) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 387.73,
    width: 0.6,
    height: 2.04,
    transform: "translate(787.3 -9.81) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 385.73,
    width: 0.6,
    height: 2.04,
    transform: "translate(785.31 -11.81) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 383.74,
    width: 0.6,
    height: 2.04,
    transform: "translate(783.31 -13.81) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 381.74,
    width: 0.6,
    height: 2.04,
    transform: "translate(781.32 -15.8) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 379.75,
    width: 0.6,
    height: 2.04,
    transform: "translate(779.32 -17.8) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 377.75,
    width: 0.6,
    height: 2.04,
    transform: "translate(777.33 -19.79) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 375.76,
    width: 0.6,
    height: 2.04,
    transform: "translate(775.33 -21.79) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 373.76,
    width: 0.6,
    height: 2.04,
    transform: "translate(773.34 -23.78) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 371.77,
    width: 0.6,
    height: 2.04,
    transform: "translate(771.34 -25.78) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 369.77,
    width: 0.6,
    height: 2.04,
    transform: "translate(769.35 -27.77) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 367.77,
    width: 0.6,
    height: 2.04,
    transform: "translate(767.35 -29.77) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 365.78,
    width: 0.6,
    height: 2.04,
    transform: "translate(765.36 -31.76) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 363.78,
    width: 0.6,
    height: 2.04,
    transform: "translate(763.36 -33.76) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 361.79,
    width: 0.6,
    height: 2.04,
    transform: "translate(761.37 -35.75) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 359.79,
    width: 0.6,
    height: 2.04,
    transform: "translate(759.37 -37.75) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 357.8,
    width: 0.6,
    height: 2.04,
    transform: "translate(757.38 -39.74) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 355.8,
    width: 0.6,
    height: 2.04,
    transform: "translate(755.38 -41.74) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 353.81,
    width: 0.6,
    height: 2.04,
    transform: "translate(753.39 -43.73) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 351.81,
    width: 0.6,
    height: 2.04,
    transform: "translate(751.39 -45.73) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 349.82,
    width: 0.6,
    height: 2.04,
    transform: "translate(749.4 -47.72) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 347.82,
    width: 0.6,
    height: 2.04,
    transform: "translate(747.4 -49.72) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 345.83,
    width: 0.6,
    height: 2.04,
    transform: "translate(745.41 -51.71) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 343.83,
    width: 0.6,
    height: 2.04,
    transform: "translate(743.41 -53.71) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 341.84,
    width: 0.6,
    height: 2.04,
    transform: "translate(741.42 -55.7) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 339.84,
    width: 0.6,
    height: 2.04,
    transform: "translate(739.42 -57.7) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 337.85,
    width: 0.6,
    height: 2.04,
    transform: "translate(737.43 -59.69) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 335.85,
    width: 0.6,
    height: 2.04,
    transform: "translate(735.43 -61.69) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 333.86,
    width: 0.6,
    height: 2.04,
    transform: "translate(733.43 -63.68) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 331.86,
    width: 0.6,
    height: 2.04,
    transform: "translate(731.44 -65.68) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 329.87,
    width: 0.6,
    height: 2.04,
    transform: "translate(729.44 -67.67) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 327.87,
    width: 0.6,
    height: 2.04,
    transform: "translate(727.45 -69.67) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 325.88,
    width: 0.6,
    height: 2.04,
    transform: "translate(725.45 -71.66) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 323.88,
    width: 0.6,
    height: 2.04,
    transform: "translate(723.46 -73.66) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 321.89,
    width: 0.6,
    height: 2.04,
    transform: "translate(721.46 -75.66) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 319.89,
    width: 0.6,
    height: 2.04,
    transform: "translate(719.47 -77.65) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 317.9,
    width: 0.6,
    height: 2.04,
    transform: "translate(717.47 -79.65) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 315.9,
    width: 0.6,
    height: 2.04,
    transform: "translate(715.48 -81.64) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 313.91,
    width: 0.6,
    height: 2.04,
    transform: "translate(713.48 -83.64) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 311.91,
    width: 0.6,
    height: 2.04,
    transform: "translate(711.49 -85.63) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 309.92,
    width: 0.6,
    height: 2.04,
    transform: "translate(709.49 -87.63) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 307.92,
    width: 0.6,
    height: 2.04,
    transform: "translate(707.5 -89.62) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 305.92,
    width: 0.6,
    height: 2.04,
    transform: "translate(705.5 -91.62) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 303.93,
    width: 0.6,
    height: 2.04,
    transform: "translate(703.51 -93.61) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 301.93,
    width: 0.6,
    height: 2.04,
    transform: "translate(701.51 -95.61) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 299.94,
    width: 0.6,
    height: 2.04,
    transform: "translate(699.52 -97.6) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 297.94,
    width: 0.6,
    height: 2.04,
    transform: "translate(697.52 -99.6) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 295.95,
    width: 0.6,
    height: 2.04,
    transform: "translate(695.53 -101.59) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 293.95,
    width: 0.6,
    height: 2.04,
    transform: "translate(693.53 -103.59) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 291.96,
    width: 0.6,
    height: 2.04,
    transform: "translate(691.54 -105.58) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 289.96,
    width: 0.6,
    height: 2.04,
    transform: "translate(689.54 -107.58) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 287.97,
    width: 0.6,
    height: 2.04,
    transform: "translate(687.55 -109.57) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 285.97,
    width: 0.6,
    height: 2.04,
    transform: "translate(685.55 -111.57) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 283.98,
    width: 0.6,
    height: 2.04,
    transform: "translate(683.56 -113.56) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 281.98,
    width: 0.6,
    height: 2.04,
    transform: "translate(681.56 -115.56) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 279.99,
    width: 0.6,
    height: 2.04,
    transform: "translate(679.57 -117.55) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 277.99,
    width: 0.6,
    height: 2.04,
    transform: "translate(677.57 -119.55) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 276,
    width: 0.6,
    height: 2.04,
    transform: "translate(675.58 -121.54) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 274,
    width: 0.6,
    height: 2.04,
    transform: "translate(673.58 -123.54) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 272.01,
    width: 0.6,
    height: 2.04,
    transform: "translate(671.58 -125.53) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 270.01,
    width: 0.6,
    height: 2.04,
    transform: "translate(669.59 -127.53) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 268.02,
    width: 0.6,
    height: 2.04,
    transform: "translate(667.59 -129.52) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 266.02,
    width: 0.6,
    height: 2.04,
    transform: "translate(665.6 -131.52) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 264.03,
    width: 0.6,
    height: 2.04,
    transform: "translate(663.6 -133.51) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 262.03,
    width: 0.6,
    height: 2.04,
    transform: "translate(661.61 -135.51) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 260.04,
    width: 0.6,
    height: 2.04,
    transform: "translate(659.61 -137.51) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 258.04,
    width: 0.6,
    height: 2.04,
    transform: "translate(657.62 -139.5) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 399.58,
    y: 257.2,
    width: 0.6,
    height: 194.79,
    transform: "translate(799.76 709.19) rotate(180)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 396.94,
    y: 257.2,
    width: 0.6,
    height: 194.79,
    transform: "translate(794.48 709.19) rotate(180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 449.58,
    width: 0.6,
    height: 2.04,
    transform: "translate(849.15 52.04) rotate(90)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 447.58,
    width: 0.6,
    height: 2.04,
    transform: "translate(847.16 50.04) rotate(90)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 445.59,
    width: 0.6,
    height: 2.04,
    transform: "translate(845.16 48.04) rotate(90)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 443.59,
    width: 0.6,
    height: 2.04,
    transform: "translate(843.17 46.05) rotate(90)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 441.6,
    width: 0.6,
    height: 2.04,
    transform: "translate(841.17 44.05) rotate(90)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 439.6,
    width: 0.6,
    height: 2.04,
    transform: "translate(839.18 42.06) rotate(90)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 437.61,
    width: 0.6,
    height: 2.04,
    transform: "translate(837.18 40.06) rotate(90)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 435.61,
    width: 0.6,
    height: 2.04,
    transform: "translate(835.19 38.07) rotate(90)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 433.62,
    width: 0.6,
    height: 2.04,
    transform: "translate(833.19 36.07) rotate(90)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 431.62,
    width: 0.6,
    height: 2.04,
    transform: "translate(831.2 34.08) rotate(90)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 429.62,
    width: 0.6,
    height: 2.04,
    transform: "translate(829.2 32.08) rotate(90)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 427.63,
    width: 0.6,
    height: 2.04,
    transform: "translate(827.21 30.09) rotate(90)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 425.63,
    width: 0.6,
    height: 2.04,
    transform: "translate(825.21 28.09) rotate(90)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 423.64,
    width: 0.6,
    height: 2.04,
    transform: "translate(823.22 26.1) rotate(90)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 421.64,
    width: 0.6,
    height: 2.04,
    transform: "translate(821.22 24.1) rotate(90)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 419.65,
    width: 0.6,
    height: 2.04,
    transform: "translate(819.23 22.11) rotate(90)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 417.65,
    width: 0.6,
    height: 2.04,
    transform: "translate(817.23 20.11) rotate(90)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 415.66,
    width: 0.6,
    height: 2.04,
    transform: "translate(815.24 18.12) rotate(90)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 413.66,
    width: 0.6,
    height: 2.04,
    transform: "translate(813.24 16.12) rotate(90)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 411.67,
    width: 0.6,
    height: 2.04,
    transform: "translate(811.25 14.13) rotate(90)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 409.67,
    width: 0.6,
    height: 2.04,
    transform: "translate(809.25 12.13) rotate(90)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 407.68,
    width: 0.6,
    height: 2.04,
    transform: "translate(807.26 10.14) rotate(90)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 405.68,
    width: 0.6,
    height: 2.04,
    transform: "translate(805.26 8.14) rotate(90)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 403.69,
    width: 0.6,
    height: 2.04,
    transform: "translate(803.27 6.15) rotate(90)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 401.69,
    width: 0.6,
    height: 2.04,
    transform: "translate(801.27 4.15) rotate(90)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 399.7,
    width: 0.6,
    height: 2.04,
    transform: "translate(799.28 2.16) rotate(90)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 397.7,
    width: 0.6,
    height: 2.04,
    transform: "translate(797.28 .16) rotate(90)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 395.71,
    width: 0.6,
    height: 2.04,
    transform: "translate(795.28 -1.83) rotate(90)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 393.71,
    width: 0.6,
    height: 2.04,
    transform: "translate(793.29 -3.83) rotate(90)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 391.72,
    width: 0.6,
    height: 2.04,
    transform: "translate(791.29 -5.82) rotate(90)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 389.72,
    width: 0.6,
    height: 2.04,
    transform: "translate(789.3 -7.82) rotate(90)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 387.73,
    width: 0.6,
    height: 2.04,
    transform: "translate(787.3 -9.81) rotate(90)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 385.73,
    width: 0.6,
    height: 2.04,
    transform: "translate(785.31 -11.81) rotate(90)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 383.74,
    width: 0.6,
    height: 2.04,
    transform: "translate(783.31 -13.81) rotate(90)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 381.74,
    width: 0.6,
    height: 2.04,
    transform: "translate(781.32 -15.8) rotate(90)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 379.75,
    width: 0.6,
    height: 2.04,
    transform: "translate(779.32 -17.8) rotate(90)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 377.75,
    width: 0.6,
    height: 2.04,
    transform: "translate(777.33 -19.79) rotate(90)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 375.76,
    width: 0.6,
    height: 2.04,
    transform: "translate(775.33 -21.79) rotate(90)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 373.76,
    width: 0.6,
    height: 2.04,
    transform: "translate(773.34 -23.78) rotate(90)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 371.77,
    width: 0.6,
    height: 2.04,
    transform: "translate(771.34 -25.78) rotate(90)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 369.77,
    width: 0.6,
    height: 2.04,
    transform: "translate(769.35 -27.77) rotate(90)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 367.77,
    width: 0.6,
    height: 2.04,
    transform: "translate(767.35 -29.77) rotate(90)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 365.78,
    width: 0.6,
    height: 2.04,
    transform: "translate(765.36 -31.76) rotate(90)"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 363.78,
    width: 0.6,
    height: 2.04,
    transform: "translate(763.36 -33.76) rotate(90)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 361.79,
    width: 0.6,
    height: 2.04,
    transform: "translate(761.37 -35.75) rotate(90)"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 359.79,
    width: 0.6,
    height: 2.04,
    transform: "translate(759.37 -37.75) rotate(90)"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 357.8,
    width: 0.6,
    height: 2.04,
    transform: "translate(757.38 -39.74) rotate(90)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 355.8,
    width: 0.6,
    height: 2.04,
    transform: "translate(755.38 -41.74) rotate(90)"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 353.81,
    width: 0.6,
    height: 2.04,
    transform: "translate(753.39 -43.73) rotate(90)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 351.81,
    width: 0.6,
    height: 2.04,
    transform: "translate(751.39 -45.73) rotate(90)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 349.82,
    width: 0.6,
    height: 2.04,
    transform: "translate(749.4 -47.72) rotate(90)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 347.82,
    width: 0.6,
    height: 2.04,
    transform: "translate(747.4 -49.72) rotate(90)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 345.83,
    width: 0.6,
    height: 2.04,
    transform: "translate(745.41 -51.71) rotate(90)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 343.83,
    width: 0.6,
    height: 2.04,
    transform: "translate(743.41 -53.71) rotate(90)"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 341.84,
    width: 0.6,
    height: 2.04,
    transform: "translate(741.42 -55.7) rotate(90)"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 339.84,
    width: 0.6,
    height: 2.04,
    transform: "translate(739.42 -57.7) rotate(90)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 337.85,
    width: 0.6,
    height: 2.04,
    transform: "translate(737.43 -59.69) rotate(90)"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 335.85,
    width: 0.6,
    height: 2.04,
    transform: "translate(735.43 -61.69) rotate(90)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 333.86,
    width: 0.6,
    height: 2.04,
    transform: "translate(733.43 -63.68) rotate(90)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 331.86,
    width: 0.6,
    height: 2.04,
    transform: "translate(731.44 -65.68) rotate(90)"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 329.87,
    width: 0.6,
    height: 2.04,
    transform: "translate(729.44 -67.67) rotate(90)"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 327.87,
    width: 0.6,
    height: 2.04,
    transform: "translate(727.45 -69.67) rotate(90)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 325.88,
    width: 0.6,
    height: 2.04,
    transform: "translate(725.45 -71.66) rotate(90)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 323.88,
    width: 0.6,
    height: 2.04,
    transform: "translate(723.46 -73.66) rotate(90)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 321.89,
    width: 0.6,
    height: 2.04,
    transform: "translate(721.46 -75.66) rotate(90)"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 319.89,
    width: 0.6,
    height: 2.04,
    transform: "translate(719.47 -77.65) rotate(90)"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 317.9,
    width: 0.6,
    height: 2.04,
    transform: "translate(717.47 -79.65) rotate(90)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 315.9,
    width: 0.6,
    height: 2.04,
    transform: "translate(715.48 -81.64) rotate(90)"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 313.91,
    width: 0.6,
    height: 2.04,
    transform: "translate(713.48 -83.64) rotate(90)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 311.91,
    width: 0.6,
    height: 2.04,
    transform: "translate(711.49 -85.63) rotate(90)"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 309.92,
    width: 0.6,
    height: 2.04,
    transform: "translate(709.49 -87.63) rotate(90)"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 307.92,
    width: 0.6,
    height: 2.04,
    transform: "translate(707.5 -89.62) rotate(90)"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 305.92,
    width: 0.6,
    height: 2.04,
    transform: "translate(705.5 -91.62) rotate(90)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 303.93,
    width: 0.6,
    height: 2.04,
    transform: "translate(703.51 -93.61) rotate(90)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 301.93,
    width: 0.6,
    height: 2.04,
    transform: "translate(701.51 -95.61) rotate(90)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 299.94,
    width: 0.6,
    height: 2.04,
    transform: "translate(699.52 -97.6) rotate(90)"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 297.94,
    width: 0.6,
    height: 2.04,
    transform: "translate(697.52 -99.6) rotate(90)"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 295.95,
    width: 0.6,
    height: 2.04,
    transform: "translate(695.53 -101.59) rotate(90)"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 293.95,
    width: 0.6,
    height: 2.04,
    transform: "translate(693.53 -103.59) rotate(90)"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 291.96,
    width: 0.6,
    height: 2.04,
    transform: "translate(691.54 -105.58) rotate(90)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 289.96,
    width: 0.6,
    height: 2.04,
    transform: "translate(689.54 -107.58) rotate(90)"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 287.97,
    width: 0.6,
    height: 2.04,
    transform: "translate(687.55 -109.57) rotate(90)"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 285.97,
    width: 0.6,
    height: 2.04,
    transform: "translate(685.55 -111.57) rotate(90)"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 283.98,
    width: 0.6,
    height: 2.04,
    transform: "translate(683.56 -113.56) rotate(90)"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 281.98,
    width: 0.6,
    height: 2.04,
    transform: "translate(681.56 -115.56) rotate(90)"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 279.99,
    width: 0.6,
    height: 2.04,
    transform: "translate(679.57 -117.55) rotate(90)"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 277.99,
    width: 0.6,
    height: 2.04,
    transform: "translate(677.57 -119.55) rotate(90)"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 276,
    width: 0.6,
    height: 2.04,
    transform: "translate(675.58 -121.54) rotate(90)"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 274,
    width: 0.6,
    height: 2.04,
    transform: "translate(673.58 -123.54) rotate(90)"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 272.01,
    width: 0.6,
    height: 2.04,
    transform: "translate(671.58 -125.53) rotate(90)"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 270.01,
    width: 0.6,
    height: 2.04,
    transform: "translate(669.59 -127.53) rotate(90)"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 268.02,
    width: 0.6,
    height: 2.04,
    transform: "translate(667.59 -129.52) rotate(90)"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 266.02,
    width: 0.6,
    height: 2.04,
    transform: "translate(665.6 -131.52) rotate(90)"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 264.03,
    width: 0.6,
    height: 2.04,
    transform: "translate(663.6 -133.51) rotate(90)"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 262.03,
    width: 0.6,
    height: 2.04,
    transform: "translate(661.61 -135.51) rotate(90)"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 260.04,
    width: 0.6,
    height: 2.04,
    transform: "translate(659.61 -137.51) rotate(90)"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 398.26,
    y: 258.04,
    width: 0.6,
    height: 2.04,
    transform: "translate(657.62 -139.5) rotate(90)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M392.97,256.67h11.19v123.51h-11.19v-123.51Zm10.13,1.05h-9.08v121.41h9.08v-121.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "393.63 379.88 404.12 373.22 393.63 366.55 393.35 366.99 403.14 373.22 393.35 379.44 393.63 379.88",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.63 366.99 404.12 360.33 393.63 353.66 393.35 354.1 403.14 360.33 393.35 366.55 393.63 366.99",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.49,
    y: 366.25,
    width: 9.98,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.63 354.1 404.12 347.44 393.63 340.77 393.35 341.21 403.14 347.44 393.35 353.66 393.63 354.1",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.49,
    y: 353.36,
    width: 9.98,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.63 341.21 404.12 334.54 393.63 327.88 393.35 328.32 403.14 334.54 393.35 340.77 393.63 341.21",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.49,
    y: 340.46,
    width: 9.98,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.63 328.32 404.12 321.65 393.63 314.99 393.35 315.43 403.14 321.65 393.35 327.88 393.63 328.32",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.49,
    y: 327.57,
    width: 9.98,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.63 315.43 404.12 308.76 393.63 302.1 393.35 302.54 403.14 308.76 393.35 314.99 393.63 315.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.49,
    y: 314.68,
    width: 9.98,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.63 302.54 404.12 295.87 393.63 289.2 393.35 289.65 403.14 295.87 393.35 302.1 393.63 302.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.49,
    y: 301.79,
    width: 9.98,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.63 289.65 404.12 282.98 393.63 276.31 393.35 276.76 403.14 282.98 393.35 289.2 393.63 289.65",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.49,
    y: 288.9,
    width: 9.98,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.63 276.76 404.12 270.09 393.63 263.42 393.35 263.87 403.14 270.09 393.35 276.31 393.63 276.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.49,
    y: 276.01,
    width: 9.98,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.55,
    y: 260.16,
    width: 12.01,
    height: 0.53,
    transform: "translate(-77.5 254.57) rotate(-32.46)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 393.49,
    y: 263.12,
    width: 9.98,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M390.44,256.67h3.58v123.51h-3.58v-123.51Zm2.53,1.05h-1.47v121.41h1.47v-121.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "393.25 379.76 393.74 379.57 391.25 373.22 393.74 366.87 393.25 366.68 390.68 373.22 393.25 379.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.25 366.87 393.74 366.68 391.25 360.33 393.74 353.98 393.25 353.78 390.68 360.33 393.25 366.87",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.01,
    y: 366.25,
    width: 2.49,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.25 353.98 393.74 353.78 391.25 347.44 393.74 341.09 393.25 340.89 390.68 347.44 393.25 353.98",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.01,
    y: 353.36,
    width: 2.49,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.25 341.09 393.74 340.89 391.25 334.54 393.74 328.2 393.25 328 390.68 334.54 393.25 341.09",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.01,
    y: 340.46,
    width: 2.49,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.25 328.2 393.74 328 391.25 321.65 393.74 315.3 393.25 315.11 390.68 321.65 393.25 328.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.01,
    y: 327.57,
    width: 2.49,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.25 315.3 393.74 315.11 391.25 308.76 393.74 302.41 393.25 302.22 390.68 308.76 393.25 315.3",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.01,
    y: 314.68,
    width: 2.49,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.25 302.41 393.74 302.22 391.25 295.87 393.74 289.52 393.25 289.33 390.68 295.87 393.25 302.41",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.01,
    y: 301.79,
    width: 2.49,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.25 289.52 393.74 289.33 391.25 282.98 393.74 276.63 393.25 276.44 390.68 282.98 393.25 289.52",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.01,
    y: 288.9,
    width: 2.49,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.25 276.63 393.74 276.44 391.25 270.09 393.74 263.74 393.25 263.55 390.68 270.09 393.25 276.63",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.01,
    y: 276.01,
    width: 2.49,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.97,
    y: 256.96,
    width: 0.53,
    height: 6.92,
    transform: "translate(-67.96 160.99) rotate(-21.39)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 391.01,
    y: 263.12,
    width: 2.49,
    height: 1.05,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M172,229.53h220.76v9.49H165.65l6.34-9.49Zm219.71,1.05H172.56l-4.94,7.39h224.08v-7.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "308.44 238.93 315.09 230.21 314.67 229.9 308.44 238.06 302.2 229.9 301.78 230.21 308.44 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.33 238.93 327.98 230.21 327.57 229.9 321.33 238.06 315.09 229.9 314.67 230.21 321.33 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.36,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.55 238.93 302.2 230.21 301.78 229.9 295.55 238.06 289.31 229.9 288.89 230.21 295.55 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.47,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.66 238.93 289.31 230.21 288.89 229.9 282.66 238.06 276.42 229.9 276 230.21 282.66 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.58,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.77 238.93 276.42 230.21 276 229.9 269.77 238.06 263.53 229.9 263.11 230.21 269.77 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.69,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.87 238.93 263.53 230.21 263.11 229.9 256.87 238.06 250.64 229.9 250.22 230.21 256.87 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.79,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.98 238.93 250.64 230.21 250.22 229.9 243.98 238.06 237.75 229.9 237.33 230.21 243.98 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.9,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.09 238.93 237.75 230.21 237.33 229.9 231.09 238.06 224.86 229.9 224.44 230.21 231.09 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.01,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.2 238.93 224.86 230.21 224.44 229.9 218.2 238.06 211.97 229.9 211.55 230.21 218.2 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.12,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.31 238.93 211.97 230.21 211.55 229.9 205.31 238.06 199.07 229.9 198.66 230.21 205.31 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.23,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.42 238.93 199.07 230.21 198.66 229.9 192.42 238.06 186.18 229.9 185.77 230.21 192.42 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.34,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.53 238.93 186.18 230.21 185.77 229.9 179.53 238.06 173.29 229.9 172.88 230.21 179.53 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.45,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.55,
    y: 234.01,
    width: 10.62,
    height: 0.53,
    transform: "translate(-119.42 227.05) rotate(-52.63)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.56,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.22 238.93 340.87 230.21 340.46 229.9 334.22 238.06 327.98 229.9 327.57 230.21 334.22 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.25,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.11 238.93 353.76 230.21 353.35 229.9 347.11 238.06 340.87 229.9 340.46 230.21 347.11 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.14,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 238.93 366.66 230.21 366.24 229.9 360 238.06 353.76 229.9 353.35 230.21 360 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.03,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.89 238.93 379.55 230.21 379.13 229.9 372.89 238.06 366.66 229.9 366.24 230.21 372.89 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.92,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.78 238.93 392.44 230.21 392.02 229.9 385.78 238.06 379.55 229.9 379.13 230.21 385.78 238.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.81,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.7,
    y: 230.06,
    width: 1.05,
    height: 8.31,
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166.99,237.97h225.77v3.76H172.36l-5.37-3.76Zm224.72,1.05H170.32l2.37,1.66h219.01v-1.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "302.09 241.45 308.44 238.78 314.78 241.45 314.99 240.96 308.44 238.21 301.89 240.96 302.09 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.99 241.45 321.33 238.78 327.67 241.45 327.88 240.96 321.33 238.21 314.78 240.96 314.99 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.36,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.2 241.45 295.55 238.78 301.89 241.45 302.09 240.96 295.55 238.21 289 240.96 289.2 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.47,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.31 241.45 282.66 238.78 289 241.45 289.2 240.96 282.66 238.21 276.11 240.96 276.31 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.58,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.42 241.45 269.77 238.78 276.11 241.45 276.31 240.96 269.77 238.21 263.22 240.96 263.42 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.69,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.53 241.45 256.87 238.78 263.22 241.45 263.42 240.96 256.87 238.21 250.33 240.96 250.53 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.79,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.33 241.45 250.53 240.96 243.98 238.21 237.44 240.96 237.64 241.45 243.98 238.78 250.33 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.9,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.75 241.45 231.09 238.78 237.44 241.45 237.64 240.96 231.09 238.21 224.55 240.96 224.75 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.01,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.86 241.45 218.2 238.78 224.55 241.45 224.75 240.96 218.2 238.21 211.65 240.96 211.86 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.12,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.97 241.45 205.31 238.78 211.65 241.45 211.86 240.96 205.31 238.21 198.76 240.96 198.97 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.23,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.08 241.45 192.42 238.78 198.76 241.45 198.97 240.96 192.42 238.21 185.87 240.96 186.08 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.34,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.19 241.45 179.53 238.78 185.87 241.45 186.08 240.96 179.53 238.21 172.98 240.96 173.19 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.45,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.61,
    y: 237.25,
    width: 0.53,
    height: 5.19,
    transform: "translate(-122.88 260.69) rotate(-58.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.56,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.88 241.45 334.22 238.78 340.56 241.45 340.77 240.96 334.22 238.21 327.67 240.96 327.88 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.25,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.77 241.45 347.11 238.78 353.45 241.45 353.66 240.96 347.11 238.21 340.56 240.96 340.77 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.14,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.66 241.45 360 238.78 366.34 241.45 366.55 240.96 360 238.21 353.45 240.96 353.66 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.03,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.55 241.45 372.89 238.78 379.24 241.45 379.44 240.96 372.89 238.21 366.34 240.96 366.55 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.92,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.44 241.45 385.78 238.78 392.13 241.45 392.33 240.96 385.78 238.21 379.24 240.96 379.44 241.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.81,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.7,
    y: 238.54,
    width: 1.05,
    height: 2.67,
    style: {
      fill: "#ebebeb"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "390.23 257.2 407.52 257.2 407.52 238.13 390.23 238.13 387.56 247.67 390.23 257.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.56 247.67 390.22 257.2 394.64 257.2 391.98 247.67 394.64 238.14 390.22 238.14 387.56 247.67",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "390.76 239.18 388.5 247.28 391.23 247.28 393.49 239.18 390.76 239.18",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.88 239.18 392.62 247.28 400.77 247.28 400.77 239.18 394.88 239.18",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.23 248.08 393.49 256.17 390.76 256.17 388.5 248.08 391.23 248.08",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "397.54 239.18 400.77 242.41 400.77 240.46 399.49 239.18 397.54 239.18",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.03 253.57 390.76 256.18 392.64 256.18 390.03 253.57",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.23 248.08 390.37 248.08 391.56 249.28 391.23 248.08",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.73 246.44 389.56 247.27 391.23 247.27 391.29 247.04 389.16 244.91 388.73 246.44",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.46 240.65 394.32 241.14 400.46 247.27 400.77 247.27 400.77 246.96 394.46 240.65",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.36 239.18 393.25 240.06 393.39 239.57 392.99 239.18 392.36 239.18",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.76 246.74 392.63 247.23 392.67 247.27 393.29 247.27 392.76 246.74",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.41 244.01 391.54 246.14 391.68 245.66 389.55 243.52 389.41 244.01",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.72 239.18 400.77 243.23 400.77 243.12 396.83 239.18 396.72 239.18",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.91 246.24 392.88 246.33 393.83 247.27 393.93 247.27 392.91 246.24",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.66 243.11 391.79 245.25 391.82 245.15 389.68 243.02 389.66 243.11",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.5 248.08 388.53 248.19 392.32 251.98 392.27 251.83 388.53 248.08 388.5 248.08",
    style: {
      fill: "#dbdbdb"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 407.52,
    y: 238.13,
    width: 25.16,
    height: 3.74,
    transform: "translate(840.2 480.01) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.52,
    y: 238.13,
    width: 25.16,
    height: 3.74,
    transform: "translate(840.2 480.01) rotate(180)",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M424.18,238.13h.35v-2.65c0-.59,.41-1.07,.91-1.07h5.9c.5,0,.91,.48,.91,1.07v2.65h.35v-2.65c0-.79-.56-1.43-1.26-1.43h-5.9c-.69,0-1.26,.64-1.26,1.43v2.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.35,
    y: 235.71,
    width: 8.06,
    height: 0.35,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.35,
    y: 237.01,
    width: 8.06,
    height: 0.35,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M415.89,238.13h.35v-2.65c0-.59,.41-1.07,.91-1.07h5.9c.5,0,.91,.48,.91,1.07v2.65h.35v-2.65c0-.79-.56-1.43-1.26-1.43h-5.9c-.69,0-1.26,.64-1.26,1.43v2.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.07,
    y: 235.71,
    width: 8.06,
    height: 0.35,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.07,
    y: 237.01,
    width: 8.06,
    height: 0.35,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M407.61,238.13h.35v-2.65c0-.59,.41-1.07,.91-1.07h5.9c.5,0,.91,.48,.91,1.07v2.65h.35v-2.65c0-.79-.56-1.43-1.26-1.43h-5.9c-.69,0-1.26,.64-1.26,1.43v2.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.78,
    y: 235.71,
    width: 8.06,
    height: 0.35,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.78,
    y: 237.01,
    width: 8.06,
    height: 0.35,
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 293.61,
    y: 238.36,
    width: 2.95,
    height: 7.79,
    transform: "translate(590.16 484.52) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.46,
    y: 238.36,
    width: 2.95,
    height: 7.79,
    transform: "translate(571.86 484.52) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.46,
    y: 243.11,
    width: 12.1,
    height: 3.04,
    transform: "translate(581.01 489.27) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 293.61,
    y: 238.36,
    width: 2.95,
    height: 7.79,
    transform: "translate(590.16 484.52) rotate(180)"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 284.46,
    y: 238.36,
    width: 2.95,
    height: 7.79,
    transform: "translate(571.86 484.52) rotate(180)"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 284.46,
    y: 243.11,
    width: 12.1,
    height: 3.04,
    transform: "translate(581.01 489.27) rotate(180)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 285.79,
    y: 246.15,
    width: 9.42,
    height: 1.16,
    transform: "translate(581.01 493.47) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 293.45,
    y: 247.3,
    width: 0.35,
    height: 73.29,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.24,
    y: 247.3,
    width: 0.35,
    height: 73.29,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.95 322.37 288.95 322.75 290.22 323.56 291.12 323.56 292.38 322.75 292.38 322.37 288.95 322.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "286.74 321.29 287.93 322.37 293.41 322.37 294.61 321.29 294.61 319.66 286.74 319.66 286.74 321.29",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.93 322.37 293.41 322.37 294.61 321.29 286.74 321.29 287.93 322.37",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290.32,323.56l.06,1.34,.29-.29c-2.4,.23-1.62,4.09,.7,3.13,.55-.22,.83-.82,.79-1.38,.05,1.2-1.49,1.76-2.25,.94-.64-.66-.24-2.17,.76-2.1l.28,.02v-.31l.07-1.34h-.7Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.41,
    y: 362.62,
    width: 66.51,
    height: 6.48,
    transform: "translate(581.33 731.71) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "262.41 363.93 290.67 328.05 318.92 363.82 319.2 363.6 290.67 327.49 262.14 363.72 262.41 363.93",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.41,
    y: 362.62,
    width: 66.51,
    height: 6.48,
    transform: "translate(581.33 731.71) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 276.59,
    y: 334.46,
    width: 28.15,
    height: 28.15,
    transform: "translate(581.33 697.08) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.99,
    y: 335.87,
    width: 25.35,
    height: 25.35,
    transform: "translate(581.33 697.08) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 300.61,
    y: 335.87,
    width: 0.82,
    height: 25.35,
    transform: "translate(602.05 697.08) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.61,
    y: 335.87,
    width: 0.26,
    height: 25.35,
    transform: "translate(601.49 697.08) rotate(180)",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 297.16,
    y: 335.87,
    width: 0.82,
    height: 25.35,
    transform: "translate(595.14 697.08) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.16,
    y: 335.87,
    width: 0.26,
    height: 25.35,
    transform: "translate(594.59 697.08) rotate(180)",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 293.71,
    y: 335.87,
    width: 0.82,
    height: 25.35,
    transform: "translate(588.24 697.08) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.71,
    y: 335.87,
    width: 0.26,
    height: 25.35,
    transform: "translate(587.68 697.08) rotate(180)",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 290.26,
    y: 335.87,
    width: 0.82,
    height: 25.35,
    transform: "translate(581.33 697.08) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.26,
    y: 335.87,
    width: 0.26,
    height: 25.35,
    transform: "translate(580.78 697.08) rotate(180)",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 286.81,
    y: 335.87,
    width: 0.82,
    height: 25.35,
    transform: "translate(574.43 697.08) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.81,
    y: 335.87,
    width: 0.26,
    height: 25.35,
    transform: "translate(573.87 697.08) rotate(180)",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 283.36,
    y: 335.87,
    width: 0.82,
    height: 25.35,
    transform: "translate(567.53 697.08) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.36,
    y: 335.87,
    width: 0.26,
    height: 25.35,
    transform: "translate(566.97 697.08) rotate(180)",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 279.9,
    y: 335.87,
    width: 0.82,
    height: 25.35,
    transform: "translate(560.62 697.08) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.9,
    y: 335.87,
    width: 0.26,
    height: 25.35,
    transform: "translate(560.07 697.08) rotate(180)",
    style: {
      opacity: 0.2
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M395.96,173.77c0,1.43,1.16,2.6,2.6,2.6s2.6-1.16,2.6-2.6-1.16-2.6-2.6-2.6-2.6,1.16-2.6,2.6Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.53,173.77c0,.57,.46,1.03,1.03,1.03s1.03-.46,1.03-1.03-.46-1.03-1.03-1.03-1.03,.46-1.03,1.03Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M431.31,241.2c0,1.43,1.16,2.6,2.6,2.6s2.6-1.16,2.6-2.6-1.16-2.6-2.6-2.6-2.6,1.16-2.6,2.6Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.87,241.2c0,.57,.46,1.03,1.03,1.03s1.03-.46,1.03-1.03-.46-1.03-1.03-1.03-1.03,.46-1.03,1.03Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.01,
    y: 227.4,
    width: 2.74,
    height: 3.76,
    transform: "translate(470.76 458.55) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 235.38,
    cy: 230.94,
    r: 1.82,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.38,
    cy: 230.94,
    r: 0.72,
    style: {
      fill: "#dbdbdb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 432.53,
    y: 277.91,
    width: 2.74,
    height: 3.76,
    transform: "translate(867.8 559.57) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432.09,281.45c0,1,.81,1.82,1.82,1.82s1.82-.81,1.82-1.82-.81-1.82-1.82-1.82-1.82,.81-1.82,1.82Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.18,281.45c0,.4,.32,.72,.72,.72s.72-.32,.72-.72-.32-.72-.72-.72-.72,.32-.72,.72Z",
    style: {
      fill: "#dbdbdb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432.09,310.69c0,1,.81,1.82,1.82,1.82s1.82-.81,1.82-1.82-.81-1.82-1.82-1.82-1.82,.81-1.82,1.82Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.18,310.69c0,.4,.32,.72,.72,.72s.72-.32,.72-.72-.32-.72-.72-.72-.72,.32-.72,.72Z",
    style: {
      fill: "#dbdbdb"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.56,445.15h0c1.89,0,3.42,1.53,3.42,3.42v3.42h-6.84v-3.42c0-1.89,1.53-3.42,3.42-3.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.56,
    cy: 448.19,
    r: 0.87,
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.79,
    y: 333.81,
    width: 21.71,
    height: 2.91,
    transform: "translate(871.3 670.54) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.3,
    y: 333.81,
    width: 3.49,
    height: 2.91,
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.79,
    y: 330.91,
    width: 21.71,
    height: 2.91,
    transform: "translate(871.3 664.72) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.3,
    y: 330.91,
    width: 3.49,
    height: 2.91,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.51,333.81c-8.4-.11-16.8-.11-25.21,0,8.4,.11,16.8,.11,25.21,0h0Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.79,
    y: 328,
    width: 21.71,
    height: 2.91,
    transform: "translate(871.3 658.9) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.3,
    y: 328,
    width: 3.49,
    height: 2.91,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.51,330.91c-8.4-.11-16.8-.11-25.21,0,8.4,.11,16.8,.11,25.21,0h0Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.79,
    y: 325.09,
    width: 21.71,
    height: 2.91,
    transform: "translate(871.3 653.08) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.3,
    y: 325.09,
    width: 3.49,
    height: 2.91,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.51,328c-8.4-.11-16.8-.11-25.21,0,8.4,.11,16.8,.11,25.21,0h0Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.79,
    y: 322.18,
    width: 21.71,
    height: 2.91,
    transform: "translate(871.3 647.26) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.3,
    y: 322.18,
    width: 3.49,
    height: 2.91,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.51,325.09c-8.4-.11-16.8-.11-25.21,0,8.4,.11,16.8,.11,25.21,0h0Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.79,
    y: 319.27,
    width: 21.71,
    height: 2.91,
    transform: "translate(871.3 641.45) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.3,
    y: 319.27,
    width: 3.49,
    height: 2.91,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.51,322.18c-8.4-.11-16.8-.11-25.21,0,8.4,.11,16.8,.11,25.21,0h0Z",
    style: {
      fill: "#a6a6a6"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 433.43,
    y: 312.48,
    width: 0.95,
    height: 6.79,
    transform: "translate(867.8 631.75) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.69,
    y: 232.75,
    width: 2.18,
    height: 231.3,
    transform: "translate(307.57 696.8) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.51,
    y: 232.75,
    width: 2.18,
    height: 231.3,
    transform: "translate(303.2 696.8) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 166.68,
    y: 267.13,
    width: 2.18,
    height: 196.92,
    transform: "translate(335.55 731.18) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.5,
    y: 267.13,
    width: 2.18,
    height: 196.92,
    transform: "translate(331.18 731.18) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.29,
    y: 292.92,
    width: 2.18,
    height: 171.13,
    transform: "translate(364.77 756.96) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.11,
    y: 292.92,
    width: 2.18,
    height: 171.13,
    transform: "translate(360.4 756.96) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110.1,
    y: 213.87,
    width: 2.18,
    height: 250.18,
    transform: "translate(222.39 677.91) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.92,
    y: 213.87,
    width: 2.18,
    height: 250.18,
    transform: "translate(218.02 677.91) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 67.52,
    y: 213.87,
    width: 2.18,
    height: 250.18,
    transform: "translate(137.22 677.91) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.33,
    y: 213.87,
    width: 2.18,
    height: 250.18,
    transform: "translate(132.85 677.91) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 65.33,
    y: 411.8,
    width: 118.14,
    height: 10.28,
    transform: "translate(248.81 833.88) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 459.38,
    width: 8.73,
    height: 4.66,
    transform: "translate(276.73 923.43) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.92,
    y: 454.72,
    width: 8.73,
    height: 4.66,
    transform: "translate(266.57 914.1) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.84,
    y: 450.06,
    width: 8.73,
    height: 4.66,
    transform: "translate(256.41 904.78) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.76,
    y: 445.4,
    width: 8.73,
    height: 4.66,
    transform: "translate(246.25 895.45) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.68,
    y: 440.73,
    width: 8.73,
    height: 4.66,
    transform: "translate(236.08 886.13) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.6,
    y: 436.07,
    width: 8.73,
    height: 4.66,
    transform: "translate(225.92 876.8) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.52,
    y: 431.41,
    width: 8.73,
    height: 4.66,
    transform: "translate(215.76 867.48) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.43,
    y: 426.74,
    width: 8.73,
    height: 4.66,
    transform: "translate(205.6 858.15) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.35,
    y: 422.08,
    width: 8.73,
    height: 4.66,
    transform: "translate(195.44 848.83) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134 464.05 93.35 426.74 98.43 426.74 139.59 464.05 134 464.05",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 65.33,
    y: 359.55,
    width: 118.14,
    height: 10.28,
    transform: "translate(248.81 729.38) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 407.14,
    width: 8.73,
    height: 4.66,
    transform: "translate(276.73 818.93) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.92,
    y: 402.47,
    width: 8.73,
    height: 4.66,
    transform: "translate(266.57 809.61) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.84,
    y: 397.81,
    width: 8.73,
    height: 4.66,
    transform: "translate(256.41 800.28) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.76,
    y: 393.15,
    width: 8.73,
    height: 4.66,
    transform: "translate(246.25 790.96) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.68,
    y: 388.48,
    width: 8.73,
    height: 4.66,
    transform: "translate(236.08 781.63) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.6,
    y: 383.82,
    width: 8.73,
    height: 4.66,
    transform: "translate(225.92 772.31) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.52,
    y: 379.16,
    width: 8.73,
    height: 4.66,
    transform: "translate(215.76 762.98) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.43,
    y: 374.5,
    width: 8.73,
    height: 4.66,
    transform: "translate(205.6 753.65) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.35,
    y: 369.83,
    width: 8.73,
    height: 4.66,
    transform: "translate(195.44 744.33) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134 411.8 93.35 374.5 98.43 374.5 139.59 411.8 134 411.8",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 65.33,
    y: 307.3,
    width: 118.14,
    height: 10.28,
    transform: "translate(248.81 624.89) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 354.89,
    width: 8.73,
    height: 4.66,
    transform: "translate(276.73 714.44) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.92,
    y: 350.22,
    width: 8.73,
    height: 4.66,
    transform: "translate(266.57 705.11) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.84,
    y: 345.56,
    width: 8.73,
    height: 4.66,
    transform: "translate(256.41 695.79) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.76,
    y: 340.9,
    width: 8.73,
    height: 4.66,
    transform: "translate(246.25 686.46) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.68,
    y: 336.24,
    width: 8.73,
    height: 4.66,
    transform: "translate(236.08 677.14) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.6,
    y: 331.57,
    width: 8.73,
    height: 4.66,
    transform: "translate(225.92 667.81) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.52,
    y: 326.91,
    width: 8.73,
    height: 4.66,
    transform: "translate(215.76 658.48) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.43,
    y: 322.25,
    width: 8.73,
    height: 4.66,
    transform: "translate(205.6 649.16) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.35,
    y: 317.58,
    width: 8.73,
    height: 4.66,
    transform: "translate(195.44 639.83) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134 359.55 93.35 322.25 98.43 322.25 139.59 359.55 134 359.55",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 65.33,
    y: 255.05,
    width: 85.17,
    height: 10.28,
    transform: "translate(215.84 520.39) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 302.64,
    width: 8.73,
    height: 4.66,
    transform: "translate(276.73 609.94) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.92,
    y: 297.98,
    width: 8.73,
    height: 4.66,
    transform: "translate(266.57 600.62) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.84,
    y: 293.31,
    width: 8.73,
    height: 4.66,
    transform: "translate(256.41 591.29) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.76,
    y: 288.65,
    width: 8.73,
    height: 4.66,
    transform: "translate(246.25 581.97) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.68,
    y: 283.99,
    width: 8.73,
    height: 4.66,
    transform: "translate(236.08 572.64) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.6,
    y: 279.33,
    width: 8.73,
    height: 4.66,
    transform: "translate(225.92 563.31) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.52,
    y: 274.66,
    width: 8.73,
    height: 4.66,
    transform: "translate(215.76 553.99) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.43,
    y: 270,
    width: 8.73,
    height: 4.66,
    transform: "translate(205.6 544.66) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.35,
    y: 265.34,
    width: 8.73,
    height: 4.66,
    transform: "translate(195.44 535.34) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134 307.3 93.35 270 98.43 270 139.59 307.3 134 307.3",
    style: {
      fill: "#dbdbdb"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-183"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.23,464.05c128.63-.61,272.91-.62,401.54,0-128.63,.62-272.91,.61-401.54,0h0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Building--inject-183"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 305.1,
    y: 372.83,
    width: 89.64,
    height: 91.22,
    transform: "translate(699.84 836.88) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.46,
    y: 319.52,
    width: 89.64,
    height: 144.53,
    transform: "translate(520.56 783.57) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.18,
    y: 319.52,
    width: 34.27,
    height: 144.53,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.81,
    y: 331.41,
    width: 17.65,
    height: 7.62,
    transform: "translate(571.28 670.44) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.81,
    y: 347.69,
    width: 17.65,
    height: 7.62,
    transform: "translate(571.28 703) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.81,
    y: 363.97,
    width: 17.65,
    height: 7.62,
    transform: "translate(571.28 735.56) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.81,
    y: 380.25,
    width: 17.65,
    height: 7.62,
    transform: "translate(571.28 768.12) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.81,
    y: 396.53,
    width: 17.65,
    height: 7.62,
    transform: "translate(571.28 800.68) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.81,
    y: 412.81,
    width: 17.65,
    height: 7.62,
    transform: "translate(571.28 833.24) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.81,
    y: 429.09,
    width: 17.65,
    height: 7.62,
    transform: "translate(571.28 865.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.42,
    y: 331.41,
    width: 17.65,
    height: 7.62,
    transform: "translate(520.49 670.44) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.42,
    y: 347.69,
    width: 17.65,
    height: 7.62,
    transform: "translate(520.49 703) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.42,
    y: 363.97,
    width: 17.65,
    height: 7.62,
    transform: "translate(520.49 735.56) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.42,
    y: 380.25,
    width: 17.65,
    height: 7.62,
    transform: "translate(520.49 768.12) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.42,
    y: 396.53,
    width: 17.65,
    height: 7.62,
    transform: "translate(520.49 800.68) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.42,
    y: 412.81,
    width: 17.65,
    height: 7.62,
    transform: "translate(520.49 833.24) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.42,
    y: 429.09,
    width: 17.65,
    height: 7.62,
    transform: "translate(520.49 865.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.09,
    y: 331.41,
    width: 17.65,
    height: 7.62,
    transform: "translate(469.83 670.44) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.09,
    y: 347.69,
    width: 17.65,
    height: 7.62,
    transform: "translate(469.83 703) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.09,
    y: 363.97,
    width: 17.65,
    height: 7.62,
    transform: "translate(469.83 735.56) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.09,
    y: 380.25,
    width: 17.65,
    height: 7.62,
    transform: "translate(469.83 768.12) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.09,
    y: 396.53,
    width: 17.65,
    height: 7.62,
    transform: "translate(469.83 800.68) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.09,
    y: 412.81,
    width: 17.65,
    height: 7.62,
    transform: "translate(469.83 833.24) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.09,
    y: 429.09,
    width: 17.65,
    height: 7.62,
    transform: "translate(469.83 865.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.46,
    y: 380.25,
    width: 17.65,
    height: 7.62,
    transform: "translate(750.57 768.12) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.46,
    y: 396.53,
    width: 17.65,
    height: 7.62,
    transform: "translate(750.57 800.68) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.46,
    y: 412.81,
    width: 17.65,
    height: 7.62,
    transform: "translate(750.57 833.24) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.46,
    y: 429.09,
    width: 17.65,
    height: 7.62,
    transform: "translate(750.57 865.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.06,
    y: 380.25,
    width: 17.65,
    height: 7.62,
    transform: "translate(699.78 768.12) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.06,
    y: 396.53,
    width: 17.65,
    height: 7.62,
    transform: "translate(699.78 800.68) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.06,
    y: 412.81,
    width: 17.65,
    height: 7.62,
    transform: "translate(699.78 833.24) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.06,
    y: 429.09,
    width: 17.65,
    height: 7.62,
    transform: "translate(699.78 865.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.73,
    y: 380.25,
    width: 17.65,
    height: 7.62,
    transform: "translate(649.12 768.12) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.73,
    y: 396.53,
    width: 17.65,
    height: 7.62,
    transform: "translate(649.12 800.68) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.73,
    y: 412.81,
    width: 17.65,
    height: 7.62,
    transform: "translate(649.12 833.24) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.73,
    y: 429.09,
    width: 17.65,
    height: 7.62,
    transform: "translate(649.12 865.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.49,
    y: 331.41,
    width: 17.65,
    height: 7.62,
    transform: "translate(396.64 670.44) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.49,
    y: 347.69,
    width: 17.65,
    height: 7.62,
    transform: "translate(396.64 703) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.49,
    y: 363.97,
    width: 17.65,
    height: 7.62,
    transform: "translate(396.64 735.56) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.49,
    y: 380.25,
    width: 17.65,
    height: 7.62,
    transform: "translate(396.64 768.12) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.49,
    y: 396.53,
    width: 17.65,
    height: 7.62,
    transform: "translate(396.64 800.68) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.49,
    y: 412.81,
    width: 17.65,
    height: 7.62,
    transform: "translate(396.64 833.24) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.49,
    y: 429.09,
    width: 17.65,
    height: 7.62,
    transform: "translate(396.64 865.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 255.5,
    y: 277.06,
    width: 3.18,
    height: 42.46,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.69,
    y: 277.06,
    width: 3.18,
    height: 42.46,
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 212.27,
    y: 277.06,
    width: 3.18,
    height: 42.46,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.46,
    y: 277.06,
    width: 3.18,
    height: 42.46,
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 298.73,
    y: 277.06,
    width: 3.18,
    height: 42.46,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.92,
    y: 277.06,
    width: 3.18,
    height: 42.46,
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 345.15,
    y: 330.27,
    width: 3.18,
    height: 42.46,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.33,
    y: 330.27,
    width: 3.18,
    height: 42.46,
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 388.38,
    y: 330.27,
    width: 3.18,
    height: 42.46,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.56,
    y: 330.27,
    width: 3.18,
    height: 42.46,
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.18,
    y: 277.06,
    width: 3.18,
    height: 42.46,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.37,
    y: 277.06,
    width: 3.18,
    height: 42.46,
    style: {
      fill: "#c7c7c7"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Crane--inject-183"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "77.54 384.85 77.04 384.85 77.04 267.15 79.07 264.46 75.88 133.23 75.91 133.17 128.41 32.99 135.47 30.56 135.56 30.59 374.73 115.12 374.56 115.59 135.47 31.09 128.76 33.4 76.38 133.35 79.58 264.62 77.54 267.32 77.54 384.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.93 384.85 82.43 384.85 82.43 267.32 80.39 264.62 80.39 264.53 83.59 133.23 83.61 133.18 132.22 36.16 132.66 36.38 84.09 133.35 80.89 264.46 82.93 267.15 82.93 384.85",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 68.14,
    y: 446.16,
    width: 95.51,
    height: 7.52,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.48,
    y: 453.68,
    width: 106.83,
    height: 10.37,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 130.03,
    y: 157.03,
    width: 0.89,
    height: 289.13,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.95,
    y: 157.03,
    width: 0.89,
    height: 289.13,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 442.57,
    width: 0.89,
    height: 3.02,
    transform: "translate(576.52 311.64) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 439.61,
    width: 0.89,
    height: 3.02,
    transform: "translate(573.56 308.68) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 436.65,
    width: 0.89,
    height: 3.02,
    transform: "translate(570.6 305.72) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 433.69,
    width: 0.89,
    height: 3.02,
    transform: "translate(567.64 302.76) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 430.72,
    width: 0.89,
    height: 3.02,
    transform: "translate(564.68 299.79) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 427.76,
    width: 0.89,
    height: 3.02,
    transform: "translate(561.71 296.83) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 424.8,
    width: 0.89,
    height: 3.02,
    transform: "translate(558.75 293.87) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 421.84,
    width: 0.89,
    height: 3.02,
    transform: "translate(555.79 290.91) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 418.88,
    width: 0.89,
    height: 3.02,
    transform: "translate(552.83 287.95) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 415.92,
    width: 0.89,
    height: 3.02,
    transform: "translate(549.87 284.99) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 412.96,
    width: 0.89,
    height: 3.02,
    transform: "translate(546.91 282.03) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 409.99,
    width: 0.89,
    height: 3.02,
    transform: "translate(543.95 279.07) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 407.03,
    width: 0.89,
    height: 3.02,
    transform: "translate(540.98 276.1) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 404.07,
    width: 0.89,
    height: 3.02,
    transform: "translate(538.02 273.14) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 401.11,
    width: 0.89,
    height: 3.02,
    transform: "translate(535.06 270.18) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 398.15,
    width: 0.89,
    height: 3.02,
    transform: "translate(532.1 267.22) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 395.19,
    width: 0.89,
    height: 3.02,
    transform: "translate(529.14 264.26) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 392.23,
    width: 0.89,
    height: 3.02,
    transform: "translate(526.18 261.3) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 389.27,
    width: 0.89,
    height: 3.02,
    transform: "translate(523.22 258.34) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 386.3,
    width: 0.89,
    height: 3.02,
    transform: "translate(520.26 255.37) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 383.34,
    width: 0.89,
    height: 3.02,
    transform: "translate(517.29 252.41) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 380.38,
    width: 0.89,
    height: 3.02,
    transform: "translate(514.33 249.45) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 377.42,
    width: 0.89,
    height: 3.02,
    transform: "translate(511.37 246.49) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 374.46,
    width: 0.89,
    height: 3.02,
    transform: "translate(508.41 243.53) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 371.5,
    width: 0.89,
    height: 3.02,
    transform: "translate(505.45 240.57) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 368.54,
    width: 0.89,
    height: 3.02,
    transform: "translate(502.49 237.61) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 365.57,
    width: 0.89,
    height: 3.02,
    transform: "translate(499.53 234.64) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 362.61,
    width: 0.89,
    height: 3.02,
    transform: "translate(496.56 231.68) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 359.65,
    width: 0.89,
    height: 3.02,
    transform: "translate(493.6 228.72) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 356.69,
    width: 0.89,
    height: 3.02,
    transform: "translate(490.64 225.76) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 353.73,
    width: 0.89,
    height: 3.02,
    transform: "translate(487.68 222.8) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 350.77,
    width: 0.89,
    height: 3.02,
    transform: "translate(484.72 219.84) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 347.81,
    width: 0.89,
    height: 3.02,
    transform: "translate(481.76 216.88) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 344.84,
    width: 0.89,
    height: 3.02,
    transform: "translate(478.8 213.92) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 341.88,
    width: 0.89,
    height: 3.02,
    transform: "translate(475.84 210.95) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 338.92,
    width: 0.89,
    height: 3.02,
    transform: "translate(472.87 207.99) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 335.96,
    width: 0.89,
    height: 3.02,
    transform: "translate(469.91 205.03) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 333,
    width: 0.89,
    height: 3.02,
    transform: "translate(466.95 202.07) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 330.04,
    width: 0.89,
    height: 3.02,
    transform: "translate(463.99 199.11) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 327.08,
    width: 0.89,
    height: 3.02,
    transform: "translate(461.03 196.15) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 324.12,
    width: 0.89,
    height: 3.02,
    transform: "translate(458.07 193.19) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 321.15,
    width: 0.89,
    height: 3.02,
    transform: "translate(455.11 190.22) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 318.19,
    width: 0.89,
    height: 3.02,
    transform: "translate(452.14 187.26) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 315.23,
    width: 0.89,
    height: 3.02,
    transform: "translate(449.18 184.3) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 312.27,
    width: 0.89,
    height: 3.02,
    transform: "translate(446.22 181.34) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 309.31,
    width: 0.89,
    height: 3.02,
    transform: "translate(443.26 178.38) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 306.35,
    width: 0.89,
    height: 3.02,
    transform: "translate(440.3 175.42) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 303.39,
    width: 0.89,
    height: 3.02,
    transform: "translate(437.34 172.46) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 300.42,
    width: 0.89,
    height: 3.02,
    transform: "translate(434.38 169.5) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 297.46,
    width: 0.89,
    height: 3.02,
    transform: "translate(431.42 166.53) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 294.5,
    width: 0.89,
    height: 3.02,
    transform: "translate(428.45 163.57) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 291.54,
    width: 0.89,
    height: 3.02,
    transform: "translate(425.49 160.61) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 288.58,
    width: 0.89,
    height: 3.02,
    transform: "translate(422.53 157.65) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 285.62,
    width: 0.89,
    height: 3.02,
    transform: "translate(419.57 154.69) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 282.66,
    width: 0.89,
    height: 3.02,
    transform: "translate(416.61 151.73) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 279.7,
    width: 0.89,
    height: 3.02,
    transform: "translate(413.65 148.77) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 276.73,
    width: 0.89,
    height: 3.02,
    transform: "translate(410.69 145.8) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 273.77,
    width: 0.89,
    height: 3.02,
    transform: "translate(407.72 142.84) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 270.81,
    width: 0.89,
    height: 3.02,
    transform: "translate(404.76 139.88) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 267.85,
    width: 0.89,
    height: 3.02,
    transform: "translate(401.8 136.92) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 264.89,
    width: 0.89,
    height: 3.02,
    transform: "translate(398.84 133.96) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 261.93,
    width: 0.89,
    height: 3.02,
    transform: "translate(395.88 131) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 258.97,
    width: 0.89,
    height: 3.02,
    transform: "translate(392.92 128.04) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 256,
    width: 0.89,
    height: 3.02,
    transform: "translate(389.96 125.08) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 253.04,
    width: 0.89,
    height: 3.02,
    transform: "translate(386.99 122.11) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 250.08,
    width: 0.89,
    height: 3.02,
    transform: "translate(384.03 119.15) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 247.12,
    width: 0.89,
    height: 3.02,
    transform: "translate(381.07 116.19) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 244.16,
    width: 0.89,
    height: 3.02,
    transform: "translate(378.11 113.23) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 241.2,
    width: 0.89,
    height: 3.02,
    transform: "translate(375.15 110.27) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 238.24,
    width: 0.89,
    height: 3.02,
    transform: "translate(372.19 107.31) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 235.28,
    width: 0.89,
    height: 3.02,
    transform: "translate(369.23 104.35) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 232.31,
    width: 0.89,
    height: 3.02,
    transform: "translate(366.27 101.38) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 229.35,
    width: 0.89,
    height: 3.02,
    transform: "translate(363.3 98.42) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 226.39,
    width: 0.89,
    height: 3.02,
    transform: "translate(360.34 95.46) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 223.43,
    width: 0.89,
    height: 3.02,
    transform: "translate(357.38 92.5) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 220.47,
    width: 0.89,
    height: 3.02,
    transform: "translate(354.42 89.54) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 217.51,
    width: 0.89,
    height: 3.02,
    transform: "translate(351.46 86.58) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 214.55,
    width: 0.89,
    height: 3.02,
    transform: "translate(348.5 83.62) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 211.58,
    width: 0.89,
    height: 3.02,
    transform: "translate(345.54 80.66) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 208.62,
    width: 0.89,
    height: 3.02,
    transform: "translate(342.57 77.69) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 205.66,
    width: 0.89,
    height: 3.02,
    transform: "translate(339.61 74.73) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 202.7,
    width: 0.89,
    height: 3.02,
    transform: "translate(336.65 71.77) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 199.74,
    width: 0.89,
    height: 3.02,
    transform: "translate(333.69 68.81) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 196.78,
    width: 0.89,
    height: 3.02,
    transform: "translate(330.73 65.85) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 193.82,
    width: 0.89,
    height: 3.02,
    transform: "translate(327.77 62.89) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 190.86,
    width: 0.89,
    height: 3.02,
    transform: "translate(324.81 59.93) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 187.89,
    width: 0.89,
    height: 3.02,
    transform: "translate(321.85 56.96) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 184.93,
    width: 0.89,
    height: 3.02,
    transform: "translate(318.88 54) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 181.97,
    width: 0.89,
    height: 3.02,
    transform: "translate(315.92 51.04) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 179.01,
    width: 0.89,
    height: 3.02,
    transform: "translate(312.96 48.08) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 176.05,
    width: 0.89,
    height: 3.02,
    transform: "translate(310 45.12) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 173.09,
    width: 0.89,
    height: 3.02,
    transform: "translate(307.04 42.16) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 170.13,
    width: 0.89,
    height: 3.02,
    transform: "translate(304.08 39.2) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 167.16,
    width: 0.89,
    height: 3.02,
    transform: "translate(301.12 36.23) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 164.2,
    width: 0.89,
    height: 3.02,
    transform: "translate(298.15 33.27) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 161.24,
    width: 0.89,
    height: 3.02,
    transform: "translate(295.19 30.31) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 158.28,
    width: 0.89,
    height: 3.02,
    transform: "translate(292.23 27.35) rotate(90)",
    style: {
      fill: "#67BB3A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 130.03,
    y: 157.03,
    width: 0.89,
    height: 289.13
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 133.95,
    y: 157.03,
    width: 0.89,
    height: 289.13
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 442.57,
    width: 0.89,
    height: 3.02,
    transform: "translate(576.52 311.64) rotate(90)"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 439.61,
    width: 0.89,
    height: 3.02,
    transform: "translate(573.56 308.68) rotate(90)"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 436.65,
    width: 0.89,
    height: 3.02,
    transform: "translate(570.6 305.72) rotate(90)"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 433.69,
    width: 0.89,
    height: 3.02,
    transform: "translate(567.64 302.76) rotate(90)"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 430.72,
    width: 0.89,
    height: 3.02,
    transform: "translate(564.68 299.79) rotate(90)"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 427.76,
    width: 0.89,
    height: 3.02,
    transform: "translate(561.71 296.83) rotate(90)"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 424.8,
    width: 0.89,
    height: 3.02,
    transform: "translate(558.75 293.87) rotate(90)"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 421.84,
    width: 0.89,
    height: 3.02,
    transform: "translate(555.79 290.91) rotate(90)"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 418.88,
    width: 0.89,
    height: 3.02,
    transform: "translate(552.83 287.95) rotate(90)"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 415.92,
    width: 0.89,
    height: 3.02,
    transform: "translate(549.87 284.99) rotate(90)"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 412.96,
    width: 0.89,
    height: 3.02,
    transform: "translate(546.91 282.03) rotate(90)"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 409.99,
    width: 0.89,
    height: 3.02,
    transform: "translate(543.95 279.07) rotate(90)"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 407.03,
    width: 0.89,
    height: 3.02,
    transform: "translate(540.98 276.1) rotate(90)"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 404.07,
    width: 0.89,
    height: 3.02,
    transform: "translate(538.02 273.14) rotate(90)"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 401.11,
    width: 0.89,
    height: 3.02,
    transform: "translate(535.06 270.18) rotate(90)"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 398.15,
    width: 0.89,
    height: 3.02,
    transform: "translate(532.1 267.22) rotate(90)"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 395.19,
    width: 0.89,
    height: 3.02,
    transform: "translate(529.14 264.26) rotate(90)"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 392.23,
    width: 0.89,
    height: 3.02,
    transform: "translate(526.18 261.3) rotate(90)"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 389.27,
    width: 0.89,
    height: 3.02,
    transform: "translate(523.22 258.34) rotate(90)"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 386.3,
    width: 0.89,
    height: 3.02,
    transform: "translate(520.26 255.37) rotate(90)"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 383.34,
    width: 0.89,
    height: 3.02,
    transform: "translate(517.29 252.41) rotate(90)"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 380.38,
    width: 0.89,
    height: 3.02,
    transform: "translate(514.33 249.45) rotate(90)"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 377.42,
    width: 0.89,
    height: 3.02,
    transform: "translate(511.37 246.49) rotate(90)"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 374.46,
    width: 0.89,
    height: 3.02,
    transform: "translate(508.41 243.53) rotate(90)"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 371.5,
    width: 0.89,
    height: 3.02,
    transform: "translate(505.45 240.57) rotate(90)"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 368.54,
    width: 0.89,
    height: 3.02,
    transform: "translate(502.49 237.61) rotate(90)"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 365.57,
    width: 0.89,
    height: 3.02,
    transform: "translate(499.53 234.64) rotate(90)"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 362.61,
    width: 0.89,
    height: 3.02,
    transform: "translate(496.56 231.68) rotate(90)"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 359.65,
    width: 0.89,
    height: 3.02,
    transform: "translate(493.6 228.72) rotate(90)"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 356.69,
    width: 0.89,
    height: 3.02,
    transform: "translate(490.64 225.76) rotate(90)"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 353.73,
    width: 0.89,
    height: 3.02,
    transform: "translate(487.68 222.8) rotate(90)"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 350.77,
    width: 0.89,
    height: 3.02,
    transform: "translate(484.72 219.84) rotate(90)"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 347.81,
    width: 0.89,
    height: 3.02,
    transform: "translate(481.76 216.88) rotate(90)"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 344.84,
    width: 0.89,
    height: 3.02,
    transform: "translate(478.8 213.92) rotate(90)"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 341.88,
    width: 0.89,
    height: 3.02,
    transform: "translate(475.84 210.95) rotate(90)"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 338.92,
    width: 0.89,
    height: 3.02,
    transform: "translate(472.87 207.99) rotate(90)"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 335.96,
    width: 0.89,
    height: 3.02,
    transform: "translate(469.91 205.03) rotate(90)"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 333,
    width: 0.89,
    height: 3.02,
    transform: "translate(466.95 202.07) rotate(90)"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 330.04,
    width: 0.89,
    height: 3.02,
    transform: "translate(463.99 199.11) rotate(90)"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 327.08,
    width: 0.89,
    height: 3.02,
    transform: "translate(461.03 196.15) rotate(90)"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 324.12,
    width: 0.89,
    height: 3.02,
    transform: "translate(458.07 193.19) rotate(90)"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 321.15,
    width: 0.89,
    height: 3.02,
    transform: "translate(455.11 190.22) rotate(90)"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 318.19,
    width: 0.89,
    height: 3.02,
    transform: "translate(452.14 187.26) rotate(90)"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 315.23,
    width: 0.89,
    height: 3.02,
    transform: "translate(449.18 184.3) rotate(90)"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 312.27,
    width: 0.89,
    height: 3.02,
    transform: "translate(446.22 181.34) rotate(90)"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 309.31,
    width: 0.89,
    height: 3.02,
    transform: "translate(443.26 178.38) rotate(90)"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 306.35,
    width: 0.89,
    height: 3.02,
    transform: "translate(440.3 175.42) rotate(90)"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 303.39,
    width: 0.89,
    height: 3.02,
    transform: "translate(437.34 172.46) rotate(90)"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 300.42,
    width: 0.89,
    height: 3.02,
    transform: "translate(434.38 169.5) rotate(90)"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 297.46,
    width: 0.89,
    height: 3.02,
    transform: "translate(431.42 166.53) rotate(90)"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 294.5,
    width: 0.89,
    height: 3.02,
    transform: "translate(428.45 163.57) rotate(90)"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 291.54,
    width: 0.89,
    height: 3.02,
    transform: "translate(425.49 160.61) rotate(90)"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 288.58,
    width: 0.89,
    height: 3.02,
    transform: "translate(422.53 157.65) rotate(90)"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 285.62,
    width: 0.89,
    height: 3.02,
    transform: "translate(419.57 154.69) rotate(90)"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 282.66,
    width: 0.89,
    height: 3.02,
    transform: "translate(416.61 151.73) rotate(90)"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 279.7,
    width: 0.89,
    height: 3.02,
    transform: "translate(413.65 148.77) rotate(90)"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 276.73,
    width: 0.89,
    height: 3.02,
    transform: "translate(410.69 145.8) rotate(90)"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 273.77,
    width: 0.89,
    height: 3.02,
    transform: "translate(407.72 142.84) rotate(90)"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 270.81,
    width: 0.89,
    height: 3.02,
    transform: "translate(404.76 139.88) rotate(90)"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 267.85,
    width: 0.89,
    height: 3.02,
    transform: "translate(401.8 136.92) rotate(90)"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 264.89,
    width: 0.89,
    height: 3.02,
    transform: "translate(398.84 133.96) rotate(90)"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 261.93,
    width: 0.89,
    height: 3.02,
    transform: "translate(395.88 131) rotate(90)"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 258.97,
    width: 0.89,
    height: 3.02,
    transform: "translate(392.92 128.04) rotate(90)"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 256,
    width: 0.89,
    height: 3.02,
    transform: "translate(389.96 125.08) rotate(90)"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 253.04,
    width: 0.89,
    height: 3.02,
    transform: "translate(386.99 122.11) rotate(90)"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 250.08,
    width: 0.89,
    height: 3.02,
    transform: "translate(384.03 119.15) rotate(90)"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 247.12,
    width: 0.89,
    height: 3.02,
    transform: "translate(381.07 116.19) rotate(90)"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 244.16,
    width: 0.89,
    height: 3.02,
    transform: "translate(378.11 113.23) rotate(90)"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 241.2,
    width: 0.89,
    height: 3.02,
    transform: "translate(375.15 110.27) rotate(90)"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 238.24,
    width: 0.89,
    height: 3.02,
    transform: "translate(372.19 107.31) rotate(90)"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 235.28,
    width: 0.89,
    height: 3.02,
    transform: "translate(369.23 104.35) rotate(90)"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 232.31,
    width: 0.89,
    height: 3.02,
    transform: "translate(366.27 101.38) rotate(90)"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 229.35,
    width: 0.89,
    height: 3.02,
    transform: "translate(363.3 98.42) rotate(90)"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 226.39,
    width: 0.89,
    height: 3.02,
    transform: "translate(360.34 95.46) rotate(90)"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 223.43,
    width: 0.89,
    height: 3.02,
    transform: "translate(357.38 92.5) rotate(90)"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 220.47,
    width: 0.89,
    height: 3.02,
    transform: "translate(354.42 89.54) rotate(90)"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 217.51,
    width: 0.89,
    height: 3.02,
    transform: "translate(351.46 86.58) rotate(90)"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 214.55,
    width: 0.89,
    height: 3.02,
    transform: "translate(348.5 83.62) rotate(90)"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 211.58,
    width: 0.89,
    height: 3.02,
    transform: "translate(345.54 80.66) rotate(90)"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 208.62,
    width: 0.89,
    height: 3.02,
    transform: "translate(342.57 77.69) rotate(90)"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 205.66,
    width: 0.89,
    height: 3.02,
    transform: "translate(339.61 74.73) rotate(90)"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 202.7,
    width: 0.89,
    height: 3.02,
    transform: "translate(336.65 71.77) rotate(90)"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 199.74,
    width: 0.89,
    height: 3.02,
    transform: "translate(333.69 68.81) rotate(90)"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 196.78,
    width: 0.89,
    height: 3.02,
    transform: "translate(330.73 65.85) rotate(90)"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 193.82,
    width: 0.89,
    height: 3.02,
    transform: "translate(327.77 62.89) rotate(90)"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 190.86,
    width: 0.89,
    height: 3.02,
    transform: "translate(324.81 59.93) rotate(90)"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 187.89,
    width: 0.89,
    height: 3.02,
    transform: "translate(321.85 56.96) rotate(90)"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 184.93,
    width: 0.89,
    height: 3.02,
    transform: "translate(318.88 54) rotate(90)"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 181.97,
    width: 0.89,
    height: 3.02,
    transform: "translate(315.92 51.04) rotate(90)"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 179.01,
    width: 0.89,
    height: 3.02,
    transform: "translate(312.96 48.08) rotate(90)"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 176.05,
    width: 0.89,
    height: 3.02,
    transform: "translate(310 45.12) rotate(90)"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 173.09,
    width: 0.89,
    height: 3.02,
    transform: "translate(307.04 42.16) rotate(90)"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 170.13,
    width: 0.89,
    height: 3.02,
    transform: "translate(304.08 39.2) rotate(90)"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 167.16,
    width: 0.89,
    height: 3.02,
    transform: "translate(301.12 36.23) rotate(90)"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 164.2,
    width: 0.89,
    height: 3.02,
    transform: "translate(298.15 33.27) rotate(90)"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 161.24,
    width: 0.89,
    height: 3.02,
    transform: "translate(295.19 30.31) rotate(90)"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 131.99,
    y: 158.28,
    width: 0.89,
    height: 3.02,
    transform: "translate(292.23 27.35) rotate(90)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M136.13,441.27h-7.38l-6.45-66.87v-36.35h20.29v36.28l-6.46,66.94Zm-6.02-1.5h4.65l6.32-65.51v-34.71h-17.3v34.78l6.32,65.44Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.04,
    y: 373.58,
    width: 18.79,
    height: 1.5,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.44 373.62 122.32 339.01 123.76 338.59 132.44 368.27 141.12 338.59 142.56 339.01 132.44 373.62",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.93 407.56 125.46 407.28 132.44 371.33 139.38 407.28 137.91 407.56 132.44 379.22 126.93 407.56",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.69,
    y: 374.33,
    width: 1.5,
    height: 66.19,
    style: {
      fill: "#67BB3A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.21,441.3h-2.6l5.44-67.03v-36.25h4.85v36.31l-7.7,66.97Zm4.41-101.72v34.75l-4.14,51,5.88-51.09v-34.66h-1.74Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.84,
    y: 373.55,
    width: 3.29,
    height: 1.56,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.26 370.99 142.7 370.99 141.06 338.84 142.62 338.76 143.48 355.69 144.35 338.76 145.91 338.84 144.26 370.99",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.98,
    y: 406.64,
    width: 66.5,
    height: 1.56,
    transform: "translate(-278.93 507.21) rotate(-84.4)",
    style: {
      fill: "#67BB3A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.21,441.3h-2.6l5.44-67.03v-36.25h4.85v36.31l-7.7,66.97Zm4.41-101.72v34.75l-4.14,51,5.88-51.09v-34.66h-1.74Z"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 141.84,
    y: 373.55,
    width: 3.29,
    height: 1.56
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "144.26 370.99 142.7 370.99 141.06 338.84 142.62 338.76 143.48 355.69 144.35 338.76 145.91 338.84 144.26 370.99"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 106.98,
    y: 406.64,
    width: 66.5,
    height: 1.56,
    transform: "translate(-278.93 507.21) rotate(-84.4)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M142.59,130.02h-20.29v-33.23l8-61.26h4.29l8,61.17v33.33Zm-18.79-1.5h17.29v-31.73l-7.82-59.76h-1.66l-7.82,59.86v31.64Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.04,
    y: 96.03,
    width: 18.79,
    height: 1.5,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.12 129.5 132.44 102.34 123.76 129.5 122.33 129.04 132.44 97.41 142.55 129.04 141.12 129.5",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.44 100.03 126.26 66.66 127.74 66.39 132.44 91.81 137.16 66.47 138.63 66.75 132.44 100.03",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.69,
    y: 36.27,
    width: 1.5,
    height: 60.51,
    style: {
      fill: "#67BB3A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.71,339.55h-16.54V156.28h16.54v183.27Zm-15.04-1.5h13.54V157.78h-13.54v180.27Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "139.76 339.11 124.22 329.23 139.76 319.35 140.16 319.98 125.62 329.23 140.16 338.48 139.76 339.11",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.76 319.98 124.22 310.1 139.76 300.21 140.16 300.85 125.62 310.1 140.16 319.35 139.76 319.98",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.15,
    y: 318.92,
    width: 14.81,
    height: 1.5,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.76 300.85 124.22 290.96 139.76 281.08 140.16 281.71 125.62 290.96 140.16 300.21 139.76 300.85",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.15,
    y: 299.78,
    width: 14.81,
    height: 1.5,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.76 281.71 124.22 271.83 139.76 261.95 140.16 262.58 125.62 271.83 140.16 281.08 139.76 281.71",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.15,
    y: 280.65,
    width: 14.81,
    height: 1.5,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.76 262.58 124.22 252.7 139.76 242.81 140.16 243.45 125.62 252.7 140.16 261.95 139.76 262.58",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.15,
    y: 261.51,
    width: 14.81,
    height: 1.5,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.76 243.45 124.22 233.56 139.76 223.68 140.16 224.31 125.62 233.56 140.16 242.81 139.76 243.45",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.15,
    y: 242.38,
    width: 14.81,
    height: 1.5,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.76 224.31 124.22 214.43 139.76 204.55 140.16 205.18 125.62 214.43 140.16 223.68 139.76 224.31",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.15,
    y: 223.25,
    width: 14.81,
    height: 1.5,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.76 205.18 124.22 195.3 139.76 185.41 140.16 186.05 125.62 195.3 140.16 204.55 139.76 205.18",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.15,
    y: 204.11,
    width: 14.81,
    height: 1.5,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.76 186.05 124.22 176.16 139.76 166.28 140.16 166.91 125.62 176.16 140.16 185.41 139.76 186.05",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.15,
    y: 184.98,
    width: 14.81,
    height: 1.5,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.07,
    y: 152.9,
    width: 0.75,
    height: 17.83,
    transform: "translate(-75.17 186.72) rotate(-57.54)",
    style: {
      fill: "#67BB3A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 125.15,
    y: 165.85,
    width: 14.81,
    height: 1.5,
    style: {
      fill: "#67BB3A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M144.49,339.58h-5.31V156.25h5.31v183.33Zm-3.75-1.56h2.19V157.81h-2.19v180.21Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 338.94 139.6 338.66 143.29 329.23 139.6 319.81 140.32 319.52 144.13 329.23 140.32 338.94",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 319.81 139.6 319.52 143.29 310.1 139.6 300.67 140.32 300.39 144.13 310.1 140.32 319.81",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 318.88,
    width: 3.69,
    height: 1.56,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 300.67 139.6 300.39 143.29 290.97 139.6 281.54 140.32 281.26 144.13 290.97 140.32 300.67",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 299.75,
    width: 3.69,
    height: 1.56,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 281.54 139.6 281.26 143.29 271.83 139.6 262.41 140.32 262.12 144.13 271.83 140.32 281.54",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 280.62,
    width: 3.69,
    height: 1.56,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 262.41 139.6 262.12 143.29 252.7 139.6 243.27 140.32 242.99 144.13 252.7 140.32 262.41",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 261.48,
    width: 3.69,
    height: 1.56,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 243.27 139.6 242.99 143.29 233.56 139.6 224.14 140.32 223.86 144.13 233.56 140.32 243.27",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 242.35,
    width: 3.69,
    height: 1.56,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 224.14 139.6 223.86 143.29 214.43 139.6 205.01 140.32 204.72 144.13 214.43 140.32 224.14",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 223.22,
    width: 3.69,
    height: 1.56,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 205.01 139.6 204.72 143.29 195.3 139.6 185.87 140.32 185.59 144.13 195.3 140.32 205.01",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 204.08,
    width: 3.69,
    height: 1.56,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 185.87 139.6 185.59 143.29 176.16 139.6 166.74 140.32 166.46 144.13 176.16 140.32 185.87",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 184.95,
    width: 3.69,
    height: 1.56,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.7,
    y: 161.42,
    width: 10.28,
    height: 0.78,
    transform: "translate(-60.56 234.87) rotate(-68.61)",
    style: {
      fill: "#67BB3A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 165.82,
    width: 3.69,
    height: 1.56,
    style: {
      fill: "#67BB3A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.49,339.58h-5.31V156.25h5.31v183.33Zm-3.75-1.56h2.19V157.81h-2.19v180.21Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 338.94 139.6 338.66 143.29 329.23 139.6 319.81 140.32 319.52 144.13 329.23 140.32 338.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 319.81 139.6 319.52 143.29 310.1 139.6 300.67 140.32 300.39 144.13 310.1 140.32 319.81"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 318.88,
    width: 3.69,
    height: 1.56
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 300.67 139.6 300.39 143.29 290.97 139.6 281.54 140.32 281.26 144.13 290.97 140.32 300.67"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 299.75,
    width: 3.69,
    height: 1.56
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 281.54 139.6 281.26 143.29 271.83 139.6 262.41 140.32 262.12 144.13 271.83 140.32 281.54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 280.62,
    width: 3.69,
    height: 1.56
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 262.41 139.6 262.12 143.29 252.7 139.6 243.27 140.32 242.99 144.13 252.7 140.32 262.41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 261.48,
    width: 3.69,
    height: 1.56
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 243.27 139.6 242.99 143.29 233.56 139.6 224.14 140.32 223.86 144.13 233.56 140.32 243.27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 242.35,
    width: 3.69,
    height: 1.56
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 224.14 139.6 223.86 143.29 214.43 139.6 205.01 140.32 204.72 144.13 214.43 140.32 224.14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 223.22,
    width: 3.69,
    height: 1.56
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 205.01 139.6 204.72 143.29 195.3 139.6 185.87 140.32 185.59 144.13 195.3 140.32 205.01"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 204.08,
    width: 3.69,
    height: 1.56
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 185.87 139.6 185.59 143.29 176.16 139.6 166.74 140.32 166.46 144.13 176.16 140.32 185.87"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 184.95,
    width: 3.69,
    height: 1.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.7,
    y: 161.42,
    width: 10.28,
    height: 0.78,
    transform: "translate(-60.56 234.87) rotate(-68.61)"
  }))), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 165.82,
    width: 3.69,
    height: 1.56
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M440.12,130.02H141.26v-14.02H430.75l9.37,14.02Zm-297.37-1.5H437.33l-7.38-11.02H142.76v11.02Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "228.25 129.88 218.39 116.97 218.98 116.51 228.25 128.65 237.52 116.51 238.12 116.97 228.25 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.12 129.88 199.26 116.97 199.85 116.51 209.12 128.65 218.39 116.51 218.98 116.97 209.12 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.94,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.39 129.88 237.52 116.97 238.12 116.51 247.39 128.65 256.66 116.51 257.25 116.97 247.39 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.07,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.52 129.88 256.66 116.97 257.25 116.51 266.52 128.65 275.79 116.51 276.38 116.97 266.52 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.2,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.65 129.88 275.79 116.97 276.38 116.51 285.65 128.65 294.92 116.51 295.52 116.97 285.65 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.34,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.79 129.88 294.92 116.97 295.52 116.51 304.79 128.65 314.06 116.51 314.65 116.97 304.79 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.47,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.92 129.88 314.06 116.97 314.65 116.51 323.92 128.65 333.19 116.51 333.79 116.97 323.92 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.6,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.05 129.88 333.19 116.97 333.79 116.51 343.05 128.65 352.32 116.51 352.92 116.97 343.05 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.74,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.19 129.88 352.32 116.97 352.92 116.51 362.19 128.65 371.46 116.51 372.05 116.97 362.19 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.87,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.32 129.88 371.46 116.97 372.05 116.51 381.32 128.65 390.59 116.51 391.19 116.97 381.32 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.45 129.88 390.59 116.97 391.19 116.51 400.45 128.65 409.72 116.51 410.32 116.97 400.45 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.14,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.59 129.88 409.72 116.97 410.32 116.51 419.59 128.65 428.86 116.51 429.45 116.97 419.59 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.27,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.56,
    y: 115.12,
    width: 0.75,
    height: 15.76,
    transform: "translate(14.43 288.68) rotate(-37.38)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.4,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.99 129.88 180.12 116.97 180.72 116.51 189.99 128.65 199.26 116.51 199.85 116.97 189.99 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.8,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.85 129.88 160.99 116.97 161.58 116.51 170.85 128.65 180.12 116.51 180.72 116.97 170.85 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.67,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.72 129.88 141.86 116.97 142.45 116.51 151.72 128.65 160.99 116.51 161.58 116.97 151.72 129.88",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.54,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.96,
    y: 116.47,
    width: 0.25,
    height: 0.75,
    transform: "translate(-36.66 160.31) rotate(-53.1)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.4,
    y: 116.74,
    width: 1.5,
    height: 12.33,
    style: {
      fill: "#67BB3A"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M142.01,128.49v1.56H433.26l-3.09,2.15h-.01l-.22,.16-.2,.14H142.01v1.56H430.23l6.88-4.8,1.06-.74,.05-.04H142.01Zm9.72,1.2l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "237.67 133.65 228.25 129.69 218.84 133.65 218.54 132.93 228.25 128.84 237.97 132.93 237.67 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.54 133.65 209.12 129.69 199.71 133.65 199.4 132.93 209.12 128.84 218.84 132.93 218.54 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.91,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.8 133.65 247.39 129.69 237.97 133.65 237.67 132.93 247.39 128.84 257.1 132.93 256.8 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.04,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.1 133.65 256.8 132.93 266.52 128.84 276.24 132.93 275.94 133.65 266.52 129.69 257.1 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.07 133.65 285.65 129.69 276.24 133.65 275.94 132.93 285.65 128.84 295.37 132.93 295.07 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.31,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.2 133.65 304.79 129.69 295.37 133.65 295.07 132.93 304.79 128.84 314.51 132.93 314.2 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.44,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.34 133.65 323.92 129.69 314.51 133.65 314.2 132.93 323.92 128.84 333.64 132.93 333.34 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.57,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.47 133.65 343.05 129.69 333.64 133.65 333.34 132.93 343.05 128.84 352.77 132.93 352.47 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.71,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.6 133.65 362.19 129.69 352.77 133.65 352.47 132.93 362.19 128.84 371.91 132.93 371.6 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.84,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.74 133.65 381.32 129.69 371.91 133.65 371.6 132.93 381.32 128.84 391.04 132.93 390.74 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.97,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.87 133.65 400.45 129.69 391.04 133.65 390.74 132.93 400.45 128.84 410.17 132.93 409.87 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.11,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429 133.65 419.59 129.69 410.17 133.65 409.87 132.93 419.59 128.84 429.31 132.93 429 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.24,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.59,
    y: 130.89,
    width: 7.71,
    height: 0.78,
    transform: "translate(-5.04 244.65) rotate(-31.41)",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.37,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.4 133.65 189.99 129.69 180.57 133.65 180.27 132.93 189.99 128.84 199.71 132.93 199.4 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.77,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.27 133.65 170.85 129.69 161.44 133.65 161.14 132.93 170.85 128.84 180.57 132.93 180.27 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.64,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.14 133.65 151.72 129.69 142.3 133.65 142 132.93 151.72 128.84 161.44 132.93 161.14 133.65",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.51,
    y: 129.33,
    width: 1.56,
    height: 3.96,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.31 132.93 142.16 133.29 142.01 133.65 142.01 132.8 142.16 132.87 142.31 132.93",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.01,
    y: 129.33,
    width: 0.93,
    height: 3.97,
    style: {
      fill: "#67BB3A"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.01,128.49v1.56H433.26l-3.09,2.15h-.01l-.22,.16-.2,.14H142.01v1.56H430.23l6.88-4.8,1.06-.74,.05-.04H142.01Zm9.72,1.2l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Zm19.14,0l-.87,.36h1.73l-.87-.36Zm19.13,0l-.87,.36h1.73l-.87-.36Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "237.67 133.65 228.25 129.69 218.84 133.65 218.54 132.93 228.25 128.84 237.97 132.93 237.67 133.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.54 133.65 209.12 129.69 199.71 133.65 199.4 132.93 209.12 128.84 218.84 132.93 218.54 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.91,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.8 133.65 247.39 129.69 237.97 133.65 237.67 132.93 247.39 128.84 257.1 132.93 256.8 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.04,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.1 133.65 256.8 132.93 266.52 128.84 276.24 132.93 275.94 133.65 266.52 129.69 257.1 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.17,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.07 133.65 285.65 129.69 276.24 133.65 275.94 132.93 285.65 128.84 295.37 132.93 295.07 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.31,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.2 133.65 304.79 129.69 295.37 133.65 295.07 132.93 304.79 128.84 314.51 132.93 314.2 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.44,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.34 133.65 323.92 129.69 314.51 133.65 314.2 132.93 323.92 128.84 333.64 132.93 333.34 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.57,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.47 133.65 343.05 129.69 333.64 133.65 333.34 132.93 343.05 128.84 352.77 132.93 352.47 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.71,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.6 133.65 362.19 129.69 352.77 133.65 352.47 132.93 362.19 128.84 371.91 132.93 371.6 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.84,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.74 133.65 381.32 129.69 371.91 133.65 371.6 132.93 381.32 128.84 391.04 132.93 390.74 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.97,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.87 133.65 400.45 129.69 391.04 133.65 390.74 132.93 400.45 128.84 410.17 132.93 409.87 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.11,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429 133.65 419.59 129.69 410.17 133.65 409.87 132.93 419.59 128.84 429.31 132.93 429 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.24,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.59,
    y: 130.89,
    width: 7.71,
    height: 0.78,
    transform: "translate(-5.04 244.65) rotate(-31.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.37,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.4 133.65 189.99 129.69 180.57 133.65 180.27 132.93 189.99 128.84 199.71 132.93 199.4 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.77,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.27 133.65 170.85 129.69 161.44 133.65 161.14 132.93 170.85 128.84 180.57 132.93 180.27 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.64,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.14 133.65 151.72 129.69 142.3 133.65 142 132.93 151.72 128.84 161.44 132.93 161.14 133.65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.51,
    y: 129.33,
    width: 1.56,
    height: 3.96
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.31 132.93 142.16 133.29 142.01 133.65 142.01 132.8 142.16 132.87 142.31 132.93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.01,
    y: 129.33,
    width: 0.93,
    height: 3.97
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "144.81 157.03 119.14 157.03 119.14 128.73 144.81 128.73 148.76 142.88 144.81 157.03",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.76 142.88 144.81 157.03 138.27 157.03 142.21 142.88 138.27 128.74 144.81 128.74 148.76 142.88",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "144.02 130.29 147.37 142.3 143.32 142.3 139.96 130.29 144.02 130.29",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.91 130.29 141.26 142.3 129.16 142.3 129.16 130.29 137.91 130.29",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.32 143.49 139.96 155.51 144.02 155.51 147.37 143.49 143.32 143.49",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "133.96 130.29 129.16 135.08 129.16 132.19 131.06 130.29 133.96 130.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.1 151.65 144.02 155.52 141.23 155.52 145.1 151.65",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.32 143.49 144.6 143.49 142.82 145.27 143.32 143.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.03 141.06 145.8 142.3 143.32 142.3 143.23 141.96 146.4 138.79 147.03 141.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.53 132.47 138.73 133.19 129.63 142.3 129.16 142.3 129.16 141.83 138.53 132.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.64 130.29 140.32 131.59 140.12 130.86 140.71 130.29 141.64 130.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.05 141.5 141.24 142.24 141.18 142.3 140.26 142.3 141.05 141.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.02 137.46 142.86 140.62 142.65 139.9 145.82 136.73 146.02 137.46",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.17 130.29 129.16 136.29 129.16 136.13 135.01 130.29 135.17 130.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.83 140.76 140.87 140.89 139.46 142.3 139.31 142.3 140.83 140.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.65 136.12 142.48 139.29 142.44 139.15 145.62 135.99 145.65 136.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.37 143.49 147.32 143.66 141.7 149.28 141.77 149.06 147.32 143.49 147.37 143.49",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.8,
    y: 128.73,
    width: 37.34,
    height: 5.56,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8,
    y: 128.73,
    width: 37.34,
    height: 5.56,
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.41,128.73h-.5v-3.93c0-.89-.61-1.61-1.36-1.61h-8.75c-.75,0-1.36,.72-1.36,1.61v3.93h-.5v-3.93c0-1.16,.83-2.11,1.86-2.11h8.75c1.02,0,1.86,.94,1.86,2.11v3.93Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.19,
    y: 125.14,
    width: 11.96,
    height: 0.5,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.19,
    y: 127.07,
    width: 11.96,
    height: 0.5,
    style: {
      fill: "#67BB3A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.7,128.73h-.5v-3.93c0-.89-.61-1.61-1.36-1.61h-8.75c-.75,0-1.36,.72-1.36,1.61v3.93h-.5v-3.93c0-1.16,.83-2.11,1.86-2.11h8.75c1.02,0,1.86,.94,1.86,2.11v3.93Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.49,
    y: 125.14,
    width: 11.96,
    height: 0.5,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.49,
    y: 127.07,
    width: 11.96,
    height: 0.5,
    style: {
      fill: "#67BB3A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119,128.73h-.5v-3.93c0-.89-.61-1.61-1.36-1.61h-8.75c-.75,0-1.36,.72-1.36,1.61v3.93h-.5v-3.93c0-1.16,.83-2.11,1.86-2.11h8.75c1.02,0,1.86,.94,1.86,2.11v3.93Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.79,
    y: 125.14,
    width: 11.96,
    height: 0.5,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.79,
    y: 127.07,
    width: 11.96,
    height: 0.5,
    style: {
      fill: "#67BB3A"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 283.85,
    y: 129.07,
    width: 4.37,
    height: 11.57,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.43,
    y: 129.07,
    width: 4.37,
    height: 11.57,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.85,
    y: 136.12,
    width: 17.96,
    height: 4.52,
    style: {
      fill: "#67BB3A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 283.85,
    y: 129.07,
    width: 4.37,
    height: 11.57
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 297.43,
    y: 129.07,
    width: 4.37,
    height: 11.57
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 283.85,
    y: 136.12,
    width: 17.96,
    height: 4.52
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 285.83,
    y: 140.64,
    width: 13.98,
    height: 1.72,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.94,
    y: 142.34,
    width: 0.5,
    height: 78.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.16,
    y: 142.34,
    width: 0.5,
    height: 78.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.13 223.76 295.13 224.33 293.24 225.52 291.91 225.52 290.03 224.33 290.03 223.76 295.13 223.76",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "298.42 222.16 296.64 223.76 288.51 223.76 286.74 222.16 286.74 219.74 298.42 219.74 298.42 222.16",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.64 223.76 288.51 223.76 286.74 222.16 298.42 222.16 296.64 223.76",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.08,225.52l-.08,1.98-.42-.42c3.54,.34,2.4,6.04-1.04,4.62-.81-.32-1.24-1.21-1.17-2.04-.08,1.76,2.2,2.63,3.35,1.4,1.05-1.23,.25-3.49-1.54-3.12l-.02-.44-.08-1.98h1Z",
    style: {
      fill: "#67BB3A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 243.23,
    y: 283.5,
    width: 98.71,
    height: 9.62,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "334.53 285.45 292.58 232.18 250.63 285.28 250.24 284.97 292.58 231.38 334.92 285.14 334.53 285.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 243.23,
    y: 283.5,
    width: 98.71,
    height: 9.62,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.23,
    y: 283.5,
    width: 98.71,
    height: 9.62,
    style: {
      opacity: 0.6
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 271.69,
    y: 241.71,
    width: 41.79,
    height: 41.79,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.77,
    y: 243.79,
    width: 37.62,
    height: 37.62,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 276.61,
    y: 243.79,
    width: 1.21,
    height: 37.62,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.43,
    y: 243.79,
    width: 0.39,
    height: 37.62,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 281.73,
    y: 243.79,
    width: 1.21,
    height: 37.62,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.55,
    y: 243.79,
    width: 0.39,
    height: 37.62,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 286.85,
    y: 243.79,
    width: 1.21,
    height: 37.62,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.68,
    y: 243.79,
    width: 0.39,
    height: 37.62,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 291.98,
    y: 243.79,
    width: 1.21,
    height: 37.62,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.8,
    y: 243.79,
    width: 0.39,
    height: 37.62,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 297.1,
    y: 243.79,
    width: 1.21,
    height: 37.62,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.92,
    y: 243.79,
    width: 0.39,
    height: 37.62,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 302.22,
    y: 243.79,
    width: 1.21,
    height: 37.62,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.05,
    y: 243.79,
    width: 0.39,
    height: 37.62,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 307.35,
    y: 243.79,
    width: 1.21,
    height: 37.62,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.17,
    y: 243.79,
    width: 0.39,
    height: 37.62,
    style: {
      opacity: 0.2
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M136.3,33.2c0,2.13-1.73,3.85-3.85,3.85s-3.85-1.73-3.85-3.85,1.73-3.85,3.85-3.85,3.85,1.73,3.85,3.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.44,
    cy: 33.2,
    r: 1.54,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.84,133.29c0,2.13-1.73,3.85-3.85,3.85s-3.85-1.73-3.85-3.85,1.73-3.85,3.85-3.85,3.85,1.73,3.85,3.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.98,
    cy: 133.29,
    r: 1.54,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 372.61,
    y: 112.79,
    width: 4.07,
    height: 5.58,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.34,118.05c0,1.49-1.21,2.69-2.69,2.69s-2.69-1.21-2.69-2.69,1.21-2.69,2.69-2.69,2.69,1.21,2.69,2.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.64,
    cy: 118.05,
    r: 1.07,
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77.95,
    y: 261.98,
    width: 4.07,
    height: 5.58,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.68,267.23c0,1.49-1.21,2.69-2.69,2.69s-2.69-1.21-2.69-2.69,1.21-2.69,2.69-2.69,2.69,1.21,2.69,2.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.98,
    cy: 267.23,
    r: 1.07,
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.68,384.85c0,1.49-1.21,2.7-2.69,2.7s-2.69-1.21-2.69-2.7,1.21-2.69,2.69-2.69,2.69,1.21,2.69,2.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.98,
    cy: 384.85,
    r: 1.07,
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.85,436h1.17c2.48,0,4.49,2.01,4.49,4.49v5.66h-10.15v-5.66c0-2.48,2.01-4.49,4.49-4.49Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.44,
    cy: 440.52,
    r: 1.28,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.28,
    y: 419.17,
    width: 32.23,
    height: 4.32,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 419.17,
    width: 5.19,
    height: 4.32,
    transform: "translate(192.19 842.67) rotate(180)",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.28,
    y: 414.86,
    width: 32.23,
    height: 4.32,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 414.86,
    width: 5.19,
    height: 4.32,
    transform: "translate(192.19 834.03) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.28,419.17c12.47-.15,24.94-.16,37.41,0-12.47,.16-24.94,.15-37.41,0h0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.28,
    y: 410.54,
    width: 32.23,
    height: 4.32,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 410.54,
    width: 5.19,
    height: 4.32,
    transform: "translate(192.19 825.39) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.28,414.86c12.47-.15,24.94-.16,37.41,0-12.47,.16-24.94,.15-37.41,0h0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.28,
    y: 406.22,
    width: 32.23,
    height: 4.32,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 406.22,
    width: 5.19,
    height: 4.32,
    transform: "translate(192.19 816.76) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.28,410.54c12.47-.15,24.94-.16,37.41,0-12.47,.16-24.94,.15-37.41,0h0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.28,
    y: 401.9,
    width: 32.23,
    height: 4.32,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 401.9,
    width: 5.19,
    height: 4.32,
    transform: "translate(192.19 808.12) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.28,406.22c12.47-.15,24.94-.16,37.41,0-12.47,.16-24.94,.15-37.41,0h0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.28,
    y: 397.58,
    width: 32.23,
    height: 4.32,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 397.58,
    width: 5.19,
    height: 4.32,
    transform: "translate(192.19 799.49) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.28,401.9c12.47-.15,24.94-.16,37.41,0-12.47,.16-24.94,.15-37.41,0h0Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 79.28,
    y: 387.51,
    width: 1.41,
    height: 10.08,
    style: {
      fill: "#67BB3A"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ground--inject-183"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M223.85,464.05h61.68s-27.85-31.29-61.68,0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.85,464.05h61.68s-27.85-31.29-61.68,0Z",
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M260.52,459.58c0-.34-.28-.62-.62-.62s-.62,.28-.62,.62,.28,.62,.62,.62,.62-.28,.62-.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.8,454.57c0-.34-.28-.62-.62-.62s-.62,.28-.62,.62,.28,.62,.62,.62,.62-.28,.62-.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.71,458.51c0-.34-.28-.62-.62-.62s-.62,.28-.62,.62,.28,.62,.62,.62,.62-.28,.62-.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.47,
    cy: 457.47,
    r: 0.62,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.28,462.04c0-.34-.28-.62-.62-.62s-.62,.28-.62,.62,.28,.62,.62,.62,.62-.28,.62-.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.33,462.66c0-.34-.28-.62-.62-.62s-.62,.28-.62,.62,.28,.62,.62,.62,.62-.28,.62-.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.73,461.19c0-.25-.2-.44-.44-.44s-.44,.2-.44,.44,.2,.44,.44,.44,.44-.2,.44-.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.63,457.03c0-.25-.2-.44-.44-.44s-.44,.2-.44,.44,.2,.44,.44,.44,.44-.2,.44-.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.89,455.88c0-.25-.2-.44-.44-.44s-.44,.2-.44,.44,.2,.44,.44,.44,.44-.2,.44-.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.35,460.2c0-.25-.2-.44-.44-.44s-.44,.2-.44,.44,.2,.44,.44,.44,.44-.2,.44-.44Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.6,464.05h42.6s-19.24-21.61-42.6,0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.6,464.05h42.6s-19.24-21.61-42.6,0Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.11,460.32c0,.34,.28,.62,.62,.62s.62-.28,.62-.62-.28-.62-.62-.62-.62,.28-.62,.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.92,461.39c0,.34,.28,.62,.62,.62s.62-.28,.62-.62-.28-.62-.62-.62-.62,.28-.62,.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.35,457.86c0,.34,.28,.62,.62,.62s.62-.28,.62-.62-.28-.62-.62-.62-.62,.28-.62,.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.9,458.71c0,.25,.2,.44,.44,.44s.44-.2,.44-.44-.2-.44-.44-.44-.44,.2-.44,.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.44,
    cy: 462.87,
    r: 0.44,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.97,461.39c0,.25,.2,.44,.44,.44s.44-.2,.44-.44-.2-.44-.44-.44-.44,.2-.44,.44Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M370.4,464.05h42.6s-19.24-21.61-42.6,0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4,464.05h42.6s-19.24-21.61-42.6,0Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M394.91,460.32c0,.34,.28,.62,.62,.62s.62-.28,.62-.62-.28-.62-.62-.62-.62,.28-.62,.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.72,461.39c0,.34,.28,.62,.62,.62s.62-.28,.62-.62-.28-.62-.62-.62-.62,.28-.62,.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.15,457.86c0,.34,.28,.62,.62,.62s.62-.28,.62-.62-.28-.62-.62-.62-.62,.28-.62,.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.14,
    cy: 458.71,
    r: 0.44,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.24,
    cy: 462.87,
    r: 0.44,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.77,461.39c0,.25,.2,.44,.44,.44s.44-.2,.44-.44-.2-.44-.44-.44-.44,.2-.44,.44Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400.2,464.05h30.2s-13.64-15.32-30.2,0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.2,464.05h30.2s-13.64-15.32-30.2,0Z",
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M418.15,461.86c0-.17-.14-.3-.3-.3s-.3,.14-.3,.3,.14,.3,.3,.3,.3-.14,.3-.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.43,459.41c0-.17-.14-.3-.3-.3s-.3,.14-.3,.3,.14,.3,.3,.3,.3-.14,.3-.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.37,461.34c0-.17-.14-.3-.3-.3s-.3,.14-.3,.3,.14,.3,.3,.3,.3-.14,.3-.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.88,
    cy: 460.83,
    r: 0.3,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.91,463.06c0-.17-.14-.3-.3-.3s-.3,.14-.3,.3,.14,.3,.3,.3,.3-.14,.3-.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.67,463.37c0-.17-.14-.3-.3-.3s-.3,.14-.3,.3,.14,.3,.3,.3,.3-.14,.3-.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.72,462.65c0-.12-.1-.22-.22-.22s-.22,.1-.22,.22,.1,.22,.22,.22,.22-.1,.22-.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.8,460.61c0-.12-.1-.22-.22-.22s-.22,.1-.22,.22,.1,.22,.22,.22,.22-.1,.22-.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.27,460.05c0-.12-.1-.22-.22-.22s-.22,.1-.22,.22,.1,.22,.22,.22,.22-.1,.22-.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.89,462.16c0-.12-.1-.22-.22-.22s-.22,.1-.22,.22,.1,.22,.22,.22,.22-.1,.22-.22Z",
    style: {
      opacity: 0.1
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fences--inject-183"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "184.22 448.33 184.03 449.66 183.83 451.08 182 464.05 179.01 464.05 180.84 451.08 181.04 449.66 181.23 448.33 184.22 448.33",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.78,448.33c-.16,1.31-.33,2.62-.5,3.94l-.53,3.93-.55,3.93-.29,1.96-.3,1.96,.24-1.97,.25-1.97,.53-3.93,.55-3.93c.19-1.31,.38-2.62,.58-3.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.03 449.66 183.83 451.08 180.84 451.08 181.04 449.66 184.03 449.66",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "198.98 448.33 199.16 449.66 199.36 451.08 201.19 464.05 204.18 464.05 202.35 451.08 202.15 449.66 201.97 448.33 198.98 448.33",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.42,448.33c.16,1.31,.33,2.62,.5,3.94l.53,3.93,.55,3.93,.29,1.96,.3,1.96-.24-1.97-.25-1.97-.53-3.93-.55-3.93c-.19-1.31-.38-2.62-.58-3.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.16 449.66 202.15 449.66 202.35 451.08 199.36 451.08 199.16 449.66",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "184.11 445.61 181.74 445.61 182.03 443.4 183.81 443.4 184.11 445.61",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.11 445.61 181.74 445.61 182.03 443.4 183.81 443.4 184.11 445.61",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 182.92,
    cy: 441.82,
    r: 2.21,
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.92,
    cy: 441.82,
    r: 1.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M184.33,441.73c-.03-.41-.24-.79-.55-1.03-.31-.24-.72-.36-1.13-.3-.39,.06-.75,.29-.97,.63-.22,.34-.3,.78-.18,1.21,.1,.35,.34,.65,.66,.83,.31,.18,.69,.23,1.03,.16,.34-.07,.65-.26,.86-.53,.21-.26,.34-.59,.35-.94,0-.02,0-.03-.01-.03,0,0-.02,.01-.02,.03,0,.14-.04,.27-.08,.4-.05,.13-.11,.25-.19,.36-.08,.11-.17,.21-.28,.3-.11,.09-.22,.16-.35,.23-.36,.17-.78,.18-1.15,.03-.37-.15-.66-.47-.78-.85-.13-.41-.06-.84,.15-1.18,.21-.33,.56-.57,.95-.62,.53-.08,1.07,.12,1.39,.55,.08,.11,.14,.23,.19,.35,.05,.12,.07,.26,.09,.39h0s0,0,0,0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.13,441.73c-.03-.35-.21-.67-.48-.88-.27-.21-.61-.3-.96-.26-.34,.05-.65,.24-.84,.54-.2,.29-.26,.68-.16,1.05,.08,.31,.29,.57,.57,.73,.27,.16,.6,.2,.9,.13,.3-.06,.56-.23,.75-.46,.18-.23,.29-.51,.31-.81,0-.01,0-.03-.01-.03,0,0-.02,.01-.02,.03-.02,.48-.33,.91-.77,1.12-.31,.15-.67,.16-.99,.03-.32-.13-.57-.41-.67-.74-.11-.35-.05-.73,.13-1.01,.18-.29,.49-.48,.81-.52,.45-.06,.9,.1,1.19,.47,.07,.09,.12,.19,.16,.3,.04,.11,.06,.22,.08,.33h0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.93,441.73c-.03-.3-.18-.56-.4-.73-.22-.17-.51-.25-.8-.22-.28,.03-.54,.2-.71,.44-.17,.24-.23,.57-.15,.89,.07,.26,.25,.49,.48,.62,.23,.13,.51,.17,.77,.11,.25-.06,.48-.2,.63-.4,.15-.2,.25-.44,.26-.69,0-.01,0-.02-.01-.02,0,0-.02,0-.02,.02-.02,.41-.28,.76-.65,.94-.26,.13-.57,.14-.84,.03-.27-.11-.49-.35-.57-.63-.09-.3-.04-.61,.12-.85,.16-.24,.41-.4,.68-.43,.19-.02,.37,0,.54,.06,.17,.06,.32,.17,.44,.32,.06,.08,.1,.16,.14,.24,.03,.09,.06,.18,.07,.28h0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.74,441.73c-.03-.24-.15-.44-.33-.58-.18-.13-.4-.2-.64-.18-.22,.02-.44,.15-.58,.34-.14,.19-.2,.46-.13,.73,.05,.22,.2,.41,.4,.52,.19,.11,.43,.14,.63,.09,.21-.05,.39-.17,.51-.33,.12-.16,.2-.36,.21-.56,0,0,0-.02-.01-.02,0,0-.02,0-.02,.02-.02,.33-.23,.61-.53,.76-.2,.11-.46,.12-.68,.03-.22-.09-.4-.28-.46-.51-.07-.24-.02-.5,.11-.69,.13-.19,.34-.31,.55-.33,.15-.01,.29,0,.43,.05,.13,.05,.26,.13,.35,.25,.05,.06,.08,.12,.11,.19,.03,.07,.05,.14,.06,.22h0Z",
    style: {
      fill: "#67BB3A"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "201.4 445.61 199.03 445.61 199.33 443.4 201.11 443.4 201.4 445.61",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.4 445.61 199.03 445.61 199.33 443.4 201.11 443.4 201.4 445.61",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M202.43,441.82c0,1.22-.99,2.21-2.21,2.21s-2.21-.99-2.21-2.21,.99-2.21,2.21-2.21,2.21,.99,2.21,2.21Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.9,441.82c0,.93-.75,1.68-1.68,1.68s-1.68-.75-1.68-1.68,.75-1.68,1.68-1.68,1.68,.75,1.68,1.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.62,441.73c-.03-.41-.24-.79-.55-1.03-.31-.24-.72-.36-1.13-.3-.39,.06-.75,.29-.97,.63-.22,.34-.3,.78-.18,1.21,.1,.35,.34,.65,.66,.83,.31,.18,.69,.23,1.03,.16,.34-.07,.65-.26,.86-.53,.21-.26,.34-.59,.35-.94,0-.02,0-.03-.01-.03,0,0-.02,.01-.02,.03,0,.14-.04,.27-.08,.4-.05,.13-.11,.25-.19,.36-.08,.11-.17,.21-.28,.3-.11,.09-.22,.16-.35,.23-.36,.17-.78,.18-1.15,.03-.37-.15-.66-.47-.78-.85-.13-.41-.06-.84,.15-1.18,.21-.33,.56-.57,.95-.62,.53-.08,1.07,.12,1.39,.55,.08,.11,.14,.23,.19,.35,.05,.12,.07,.26,.09,.39h0s0,0,0,0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.43,441.73c-.03-.35-.21-.67-.48-.88-.27-.21-.61-.3-.96-.26-.34,.05-.65,.24-.84,.54-.2,.29-.26,.68-.16,1.05,.08,.31,.29,.57,.57,.73,.27,.16,.6,.2,.9,.13,.3-.06,.56-.23,.75-.46,.18-.23,.29-.51,.31-.81,0-.01,0-.03-.01-.03,0,0-.02,.01-.02,.03-.02,.48-.33,.91-.77,1.12-.31,.15-.68,.16-.99,.03-.32-.13-.57-.41-.67-.74-.11-.35-.05-.73,.13-1.01,.18-.29,.49-.48,.81-.52,.45-.06,.9,.1,1.19,.47,.07,.09,.12,.19,.16,.3,.04,.11,.06,.22,.08,.33h0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.23,441.73c-.03-.3-.18-.56-.4-.73-.22-.17-.51-.25-.8-.22-.28,.03-.54,.2-.71,.44-.17,.24-.23,.57-.15,.89,.07,.26,.25,.49,.48,.62,.23,.13,.51,.17,.77,.11,.25-.06,.48-.2,.63-.4,.15-.2,.25-.44,.26-.69,0-.01,0-.02-.01-.02,0,0-.02,0-.02,.02-.02,.41-.28,.76-.65,.94-.26,.13-.57,.14-.84,.03-.27-.11-.49-.35-.57-.63-.09-.3-.04-.61,.12-.85,.16-.24,.41-.4,.68-.43,.19-.02,.37,0,.54,.06,.17,.06,.32,.17,.44,.32,.06,.08,.1,.16,.14,.24,.03,.09,.06,.18,.07,.28h0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.03,441.73c-.03-.24-.15-.44-.33-.58-.18-.13-.4-.2-.64-.18-.22,.02-.44,.15-.58,.34-.14,.19-.2,.46-.13,.73,.05,.22,.2,.41,.4,.52,.19,.11,.43,.14,.63,.09,.21-.05,.39-.17,.51-.33,.12-.16,.2-.36,.21-.56,0,0,0-.02-.01-.02,0,0-.02,0-.02,.02-.02,.33-.23,.61-.53,.76-.2,.11-.46,.12-.68,.03-.22-.09-.4-.28-.46-.51-.07-.24-.02-.5,.11-.69,.13-.19,.34-.31,.55-.33,.15-.01,.29,0,.43,.05,.13,.05,.26,.13,.35,.25,.05,.06,.08,.12,.11,.19,.03,.07,.05,.14,.06,.22h0Z",
    style: {
      fill: "#67BB3A"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 176.7,
    y: 444.49,
    width: 29.79,
    height: 5.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,450.26h-29.93v-5.84h29.93v5.84Zm-29.79-.14h29.65v-5.56h-29.65v5.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "182.82 444.49 180.66 450.19 176.81 450.19 178.98 444.49 182.82 444.49",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.71 444.49 188.55 450.19 184.7 450.19 186.86 444.49 190.71 444.49",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.6 444.49 196.43 450.19 192.59 450.19 194.75 444.49 198.6 444.49",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.48 444.49 204.32 450.19 200.47 450.19 202.63 444.49 206.48 444.49",
    style: {
      fill: "#67BB3A"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 177.3,
    y: 457.15,
    width: 28.58,
    height: 3.61,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.96,460.83h-28.73v-3.75h28.73v3.75Zm-28.58-.14h28.44v-3.46h-28.44v3.46Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "183.18 457.15 181.1 460.76 177.41 460.76 179.49 457.15 183.18 457.15",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.75 457.15 188.67 460.76 184.98 460.76 187.05 457.15 190.75 457.15",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.31 457.15 196.24 460.76 192.55 460.76 194.62 457.15 198.31 457.15",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.88 457.15 203.8 460.76 200.11 460.76 202.19 457.15 205.88 457.15",
    style: {
      fill: "#67BB3A"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M196.23,447.34c0,2.56-2.08,4.64-4.64,4.64s-4.64-2.08-4.64-4.64,2.08-4.64,4.64-4.64,4.64,2.08,4.64,4.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.6,452.04c-2.6,0-4.71-2.11-4.71-4.71s2.11-4.71,4.71-4.71,4.71,2.11,4.71,4.71-2.11,4.71-4.71,4.71Zm0-9.27c-2.52,0-4.56,2.05-4.56,4.57s2.05,4.56,4.56,4.56,4.56-2.05,4.56-4.56-2.05-4.57-4.56-4.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.53,447.34c0,2.17-1.76,3.93-3.93,3.93s-3.93-1.76-3.93-3.93,1.76-3.93,3.93-3.93,3.93,1.76,3.93,3.93Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.13,
    y: 446.88,
    width: 4.93,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "359.83 448.33 359.64 449.66 359.44 451.08 357.61 464.05 354.62 464.05 356.45 451.08 356.65 449.66 356.84 448.33 359.83 448.33",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.4,448.33c-.16,1.31-.33,2.62-.5,3.94l-.53,3.93-.55,3.93-.29,1.96-.3,1.96,.24-1.97,.25-1.97,.53-3.93,.55-3.93c.19-1.31,.38-2.62,.58-3.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.64 449.66 359.44 451.08 356.45 451.08 356.65 449.66 359.64 449.66",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "374.59 448.33 374.77 449.66 374.98 451.08 376.8 464.05 379.79 464.05 377.97 451.08 377.76 449.66 377.58 448.33 374.59 448.33",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.03,448.33c.16,1.31,.33,2.62,.5,3.94l.53,3.93,.55,3.93,.29,1.96,.3,1.96-.24-1.97-.25-1.97-.53-3.93-.55-3.93c-.19-1.31-.38-2.62-.58-3.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.77 449.66 377.76 449.66 377.97 451.08 374.98 451.08 374.77 449.66",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "359.72 445.61 357.35 445.61 357.64 443.4 359.43 443.4 359.72 445.61",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.72 445.61 357.35 445.61 357.64 443.4 359.43 443.4 359.72 445.61",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M360.74,441.82c0,1.22-.99,2.21-2.21,2.21s-2.21-.99-2.21-2.21,.99-2.21,2.21-2.21,2.21,.99,2.21,2.21Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.21,441.82c0,.93-.75,1.68-1.68,1.68s-1.68-.75-1.68-1.68,.75-1.68,1.68-1.68,1.68,.75,1.68,1.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M359.94,441.73c-.03-.41-.24-.79-.55-1.03-.31-.24-.72-.36-1.13-.3-.39,.06-.75,.29-.97,.63-.22,.34-.3,.78-.18,1.21,.1,.35,.34,.65,.66,.83,.31,.18,.69,.23,1.03,.16,.34-.07,.65-.26,.86-.53,.21-.26,.34-.59,.35-.94,0-.02,0-.03-.01-.03,0,0-.02,.01-.02,.03,0,.14-.04,.27-.08,.4-.05,.13-.11,.25-.19,.36-.08,.11-.17,.21-.28,.3-.11,.09-.22,.16-.35,.23-.36,.17-.78,.18-1.15,.03-.37-.15-.66-.47-.78-.85-.13-.41-.06-.84,.15-1.18,.21-.33,.56-.57,.95-.62,.53-.08,1.07,.12,1.39,.55,.08,.11,.14,.23,.19,.35,.05,.12,.07,.26,.09,.39h0s0,0,0,0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.74,441.73c-.03-.35-.21-.67-.48-.88-.27-.21-.61-.3-.96-.26-.34,.05-.65,.24-.84,.54-.2,.29-.26,.68-.16,1.05,.08,.31,.29,.57,.57,.73,.27,.16,.6,.2,.9,.13,.3-.06,.56-.23,.75-.46,.18-.23,.29-.51,.31-.81,0-.01,0-.03-.01-.03,0,0-.02,.01-.02,.03-.02,.48-.33,.91-.77,1.12-.31,.15-.67,.16-.99,.03-.32-.13-.57-.41-.67-.74-.11-.35-.05-.73,.13-1.01,.18-.29,.49-.48,.81-.52,.45-.06,.9,.1,1.19,.47,.07,.09,.12,.19,.16,.3,.04,.11,.06,.22,.08,.33h0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.55,441.73c-.03-.3-.18-.56-.4-.73-.22-.17-.51-.25-.8-.22-.28,.03-.54,.2-.71,.44-.17,.24-.23,.57-.15,.89,.07,.26,.25,.49,.48,.62,.23,.13,.51,.17,.77,.11,.25-.06,.48-.2,.63-.4,.15-.2,.25-.44,.26-.69,0-.01,0-.02-.01-.02,0,0-.02,0-.02,.02-.02,.41-.28,.76-.65,.94-.26,.13-.57,.14-.84,.03-.27-.11-.49-.35-.57-.63-.09-.3-.04-.61,.12-.85,.16-.24,.41-.4,.68-.43,.19-.02,.37,0,.54,.06,.17,.06,.32,.17,.44,.32,.06,.08,.1,.16,.14,.24,.03,.09,.06,.18,.07,.28h0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.35,441.73c-.03-.24-.15-.44-.33-.58-.18-.13-.4-.2-.64-.18-.22,.02-.44,.15-.58,.34-.14,.19-.2,.46-.13,.73,.05,.22,.2,.41,.4,.52,.19,.11,.43,.14,.63,.09,.21-.05,.39-.17,.51-.33,.12-.16,.2-.36,.21-.56,0,0,0-.02-.01-.02,0,0-.02,0-.02,.02-.02,.33-.23,.61-.53,.76-.2,.11-.46,.12-.68,.03-.22-.09-.4-.28-.46-.51-.07-.24-.02-.5,.11-.69,.13-.19,.34-.31,.55-.33,.15-.01,.29,0,.43,.05,.13,.05,.26,.13,.35,.25,.05,.06,.08,.12,.11,.19,.03,.07,.05,.14,.06,.22h0Z",
    style: {
      fill: "#67BB3A"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "377.02 445.61 374.65 445.61 374.94 443.4 376.72 443.4 377.02 445.61",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.02 445.61 374.65 445.61 374.94 443.4 376.72 443.4 377.02 445.61",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M378.04,441.82c0,1.22-.99,2.21-2.21,2.21s-2.21-.99-2.21-2.21,.99-2.21,2.21-2.21,2.21,.99,2.21,2.21Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.51,441.82c0,.93-.75,1.68-1.68,1.68s-1.68-.75-1.68-1.68,.75-1.68,1.68-1.68,1.68,.75,1.68,1.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.24,441.73c-.03-.41-.24-.79-.55-1.03-.31-.24-.72-.36-1.13-.3-.39,.06-.75,.29-.97,.63-.22,.34-.3,.78-.18,1.21,.1,.35,.34,.65,.66,.83,.31,.18,.69,.23,1.03,.16,.34-.07,.65-.26,.86-.53,.21-.26,.34-.59,.35-.94,0-.02,0-.03-.01-.03,0,0-.02,.01-.02,.03,0,.14-.04,.27-.08,.4-.05,.13-.11,.25-.19,.36-.08,.11-.17,.21-.28,.3-.11,.09-.22,.16-.35,.23-.36,.17-.78,.18-1.15,.03-.37-.15-.66-.47-.78-.85-.13-.41-.06-.84,.15-1.18,.21-.33,.56-.57,.95-.62,.53-.08,1.07,.12,1.39,.55,.08,.11,.14,.23,.19,.35,.05,.12,.07,.26,.09,.39h0s0,0,0,0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.04,441.73c-.03-.35-.21-.67-.48-.88-.27-.21-.61-.3-.96-.26-.34,.05-.65,.24-.84,.54-.2,.29-.26,.68-.16,1.05,.08,.31,.29,.57,.57,.73,.27,.16,.6,.2,.9,.13,.3-.06,.56-.23,.75-.46,.18-.23,.29-.51,.31-.81,0-.01,0-.03-.01-.03,0,0-.02,.01-.02,.03-.02,.48-.33,.91-.77,1.12-.31,.15-.68,.16-.99,.03-.32-.13-.57-.41-.67-.74-.11-.35-.05-.73,.13-1.01,.18-.29,.49-.48,.81-.52,.45-.06,.9,.1,1.19,.47,.07,.09,.12,.19,.16,.3,.04,.11,.06,.22,.08,.33h0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.84,441.73c-.03-.3-.18-.56-.4-.73-.22-.17-.51-.25-.8-.22-.28,.03-.54,.2-.71,.44-.17,.24-.23,.57-.15,.89,.07,.26,.25,.49,.48,.62,.23,.13,.51,.17,.77,.11,.25-.06,.48-.2,.63-.4,.15-.2,.25-.44,.26-.69,0-.01,0-.02-.01-.02,0,0-.02,0-.02,.02-.02,.41-.28,.76-.65,.94-.26,.13-.57,.14-.84,.03-.27-.11-.49-.35-.57-.63-.09-.3-.04-.61,.12-.85,.16-.24,.41-.4,.68-.43,.19-.02,.37,0,.54,.06,.17,.06,.32,.17,.44,.32,.06,.08,.1,.16,.14,.24,.03,.09,.06,.18,.07,.28h0Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.65,441.73c-.03-.24-.15-.44-.33-.58-.18-.13-.4-.2-.64-.18-.22,.02-.44,.15-.58,.34-.14,.19-.2,.46-.13,.73,.05,.22,.2,.41,.4,.52,.19,.11,.43,.14,.63,.09,.21-.05,.39-.17,.51-.33,.12-.16,.2-.36,.21-.56,0,0,0-.02-.01-.02,0,0-.02,0-.02,.02-.02,.33-.23,.61-.53,.76-.2,.11-.46,.12-.68,.03-.22-.09-.4-.28-.46-.51-.07-.24-.02-.5,.11-.69,.13-.19,.34-.31,.55-.33,.15-.01,.29,0,.43,.05,.13,.05,.26,.13,.35,.25,.05,.06,.08,.12,.11,.19,.03,.07,.05,.14,.06,.22h0Z",
    style: {
      fill: "#67BB3A"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352.31,
    y: 444.49,
    width: 29.79,
    height: 5.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.17,450.26h-29.93v-5.84h29.93v5.84Zm-29.79-.14h29.65v-5.56h-29.65v5.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "358.44 444.49 356.27 450.19 352.43 450.19 354.59 444.49 358.44 444.49",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.32 444.49 364.16 450.19 360.31 450.19 362.47 444.49 366.32 444.49",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.21 444.49 372.05 450.19 368.2 450.19 370.36 444.49 374.21 444.49",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.09 444.49 379.93 450.19 376.08 450.19 378.25 444.49 382.09 444.49",
    style: {
      fill: "#67BB3A"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352.92,
    y: 457.15,
    width: 28.58,
    height: 3.61,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.57,460.83h-28.73v-3.75h28.73v3.75Zm-28.58-.14h28.44v-3.46h-28.44v3.46Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "358.79 457.15 356.72 460.76 353.03 460.76 355.1 457.15 358.79 457.15",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.36 457.15 364.28 460.76 360.59 460.76 362.67 457.15 366.36 457.15",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.92 457.15 371.85 460.76 368.16 460.76 370.23 457.15 373.92 457.15",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.49 457.15 379.42 460.76 375.72 460.76 377.8 457.15 381.49 457.15",
    style: {
      fill: "#67BB3A"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M371.84,447.34c0,2.56-2.08,4.64-4.64,4.64s-4.64-2.08-4.64-4.64,2.08-4.64,4.64-4.64,4.64,2.08,4.64,4.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.21,452.04c-2.6,0-4.71-2.11-4.71-4.71s2.11-4.71,4.71-4.71,4.71,2.11,4.71,4.71-2.11,4.71-4.71,4.71Zm0-9.27c-2.52,0-4.56,2.05-4.56,4.57s2.05,4.56,4.56,4.56,4.56-2.05,4.56-4.56-2.05-4.57-4.56-4.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371.14,447.34c0,2.17-1.76,3.93-3.93,3.93s-3.93-1.76-3.93-3.93,1.76-3.93,3.93-3.93,3.93,1.76,3.93,3.93Z",
    style: {
      fill: "#67BB3A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.74,
    y: 446.88,
    width: 4.93,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructioncraneCuate);
export default __webpack_public_path__ + "static/media/Construction crane-cuate.94a59966044df6a01c87e0ac6226e0f8.svg";
export { ForwardRef as ReactComponent };